<template>
    <div class="page-container">
        <div class="pageHead"
            :class="{
                'pageHead--up': isToUp
            }"
            ref="pageHead"
        >
            <div class="pagehead" ref="pagehead">
                <template v-if="QS_type === ''">
                    <div class="pagehead-title" style="display: none;">女士雪地靴女士</div>
                     <h2 class="pagehead-likeInput">
                        <span @click="event_showPanelSearch">{{ QS_keyword }}</span>
                    </h2>
                    <a href="#" class="pagehead-btnBack" @click.prevent="event_goBack">
                        <i class="iconfont icon-back"></i>
                    </a>
                    <a href="#" class="pagehead-btnSelect"
                        :class="{
                            'pagehead-btnSelect--gray': initLoadFlag && res_productList.length === 0,
                            'pagehead-btnSelect--selected': isHasSelectedMenu()
                        }"
                        @click.prevent="event_showComplexScreening"
                    >筛选</a>
                </template>
                <template v-else>
                    <div class="pagehead-title">{{ QS_keyword }}</div>
                    <a href="#" class="pagehead-btnBack" @click.prevent="event_goBack">
                        <i class="iconfont icon-back"></i>
                    </a>
                    <a href="#" class="pagehead-search" @click.prevent="event_showPanelSearch">
                        <i class="iconfont icon-search"></i>
                    </a>
                    <a href="#" class="pagehead-btnSelect"
                        :class="{
                            'pagehead-btnSelect--gray': initLoadFlag && res_productList.length === 0,
                            'pagehead-btnSelect--selected': isHasSelectedMenu()
                        }"
                        @click.prevent="event_showComplexScreening"
                    >筛选</a>
                </template>
            </div>
            <div class="sort-wapBox" v-if="initLoadEnd === false && res_productList.length === 0">
                <div class="sort-wrap">
                    <div class="sort-box sort--4">
                        <div class="sort">
                            <div class="sort-item"></div>
                            <div class="sort-item"></div>
                            <div class="sort-item"></div>
                            <div class="sort-item"></div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="sort-wapBox" v-else-if="
                res_sortList.length &&
                (
                    (initLoadEnd && res_productList.length) ||
                    initLoadFlag === false
                )
            ">
                <div class="sort-wrap" ref="sortWrap">
                    <div class="sort-box"
                        :class="{
                             'sort--2': (res_sortList.length + res_filteroutlist.length) === 2,
                             'sort--3': (res_sortList.length + res_filteroutlist.length) === 3,
                             'sort--4': (res_sortList.length + res_filteroutlist.length) === 4,
                             'sort--more': (res_sortList.length + res_filteroutlist.length) >= 5
                        }"
                    >
                        <div class="sort">
                            <div class="sort-item"
                                :class="{
                                    'selected': index === nowSingleIndex
                                }"
                                v-for="(row, index) in req_data['list_' + res_sortList[0].key]"
                                @click="event_toggleDropdownMenu($event, index, row, row.showMenu, true)"
                            >
                                <span>{{ row.value[0].name }}</span>
                                <i class="sort-arrow"
                                    v-if="row.showMenu"
                                    :class="{
                                        up: (row.key+index) === currentSortMenu.key  && currentSortMenu.isShow
                                    }"
                                ></i>
                            </div>
                            <div class="sort-item"
                                :class="{
                                    'selected': req_data[row.key] instanceof Array ? (req_data[row.key].length ? true : false) : (req_data[row.key] ? true : false)
                                }"
                                v-for="(row, index) in res_filteroutlist"
                                v-if="row.name"
                                @click="event_toggleDropdownMenu($event, index, row, row.multiple, false)"
                            >
                                <span>{{ getSelectedMenuName(row, false) }}</span>
                                <i class="sort-arrow"
                                    v-if="row.multiple"
                                    :class="{
                                        up: row.key === currentSortMenu.key  && currentSortMenu.isShow
                                    }"
                                ></i>
                            </div>
                            <div class="sort-item" v-else
                                :class="{
                                    'show': true,
                                    'selected': req_data[row.key] instanceof Array ? (req_data[row.key].length ? true : false) : (req_data[row.key] ? true : false)
                                }"
                                :style="{
                                    backgroundImage: 'url(' + (req_data[row.key] ? row.clickImg.replace(/^https?:/, '') : row.img.replace(/^https?:/, '')) + ')'
                                }"
                                @click="event_toggleDropdownMenu($event, index, row, row.multiple, false)"
                            ></div>
                            <!-- <div class="sort-item">
                                <img style="display: none;" v-else :src="row.img.replace(/^https?:/, '')" />
                            </div> -->
                        </div>
                    </div>
                    <transition-group name="slide-down" tag="div" class="sortMenu-container">
                        <div class="sortMenu"
                            :class="{
                                'sortMenu--full': isShowSortMenuFull,
                                'sortMenu--index': currentSortMenu.key === (row.key + rowIndex) && currentSortMenu.isShow
                            }"
                            v-for="(row, rowIndex) in res_sortList"
                            :key="row.key + rowIndex"
                            v-if="row.showMenu"
                            v-show="currentSortMenu.key === (row.key + rowIndex) && currentSortMenu.isShow"
                            :ref="row.key + rowIndex"
                        >
                            <div class="sortMenu-content">
                                <ul>
                                    <li class="sortMenu-item"
                                        :class="{
                                            selected: item.id === req_data[row.key]
                                        }"
                                        v-for="(item, index) in row.value"
                                        @click="event_selectedItem(row.key, item, true, rowIndex, index, true)"
                                    >
                                        <span>{{ item.name }}</span>
                                        <i class="iconfont icon-selected"></i>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div class="sortMenu"
                            :class="{
                                'sortMenu--full': isShowSortMenuFull,
                                'sortMenu--index': currentSortMenu.key === row.key && currentSortMenu.isShow
                            }"
                            v-for="(row, rowIndex) in res_filteroutlist"
                            :key="row.key"
                            v-if="row.multiple"
                            v-show="currentSortMenu.key === row.key && currentSortMenu.isShow"
                            :ref="row.key"
                        >
                            <div class="sortMenu-content sortMenu--2">
                                <ul>
                                    <li class="sortMenu-item"
                                        :class="{
                                            selected: req_data['tmp_key__'+row.key].indexOf(item.id) !== -1
                                        }"
                                        v-for="(item, index) in row.value"
                                        @click="event_selectedItem(row.key, item, row.multiple === 0, rowIndex, index, false)"
                                    >
                                        <span>{{ item.name }}</span>
                                        <i class="iconfont icon-selected"></i>
                                    </li>
                                </ul>
                            </div>
                            <div class="menu-btns">
                                <a href="#" @click.prevent="event_clearSortMenu(row.key)">清空</a>
                                <a href="#" @click.prevent="event_submitSortMenu(row.key)">确定</a>
                            </div>
                        </div>
                    </transition-group>
                </div>
            </div>
        </div>
        <!-- 主体内容-->
        <div class="page"
            ref="page"
            :class="{
                'page--noResult': initLoadFlag && !loading && res_productList.length === 0,
                'page--hidden': isAddPageHidden
            }"
            @scroll="event_pageScroll"
            >

            <div class="pageContent" v-if="initLoadEnd === false">
                <ul class="listGoods listGoods--loading">
                    <li class="listGoods-item" v-for="num in 10">
                        <div class="listGoods-imgBox" :class="getRndBgColor()"></div>
                        <div class="listGoods-info">
                            <p class="line line1"></p>
                            <p class="line line2"></p>
                            <p class="line line3"></p>
                            <p class="line line4"></p>
                            <p class="line line5"></p>
                        </div>
                    </li>
                </ul>
            </div>
            <div class="pageContent" v-else-if="initLoadFlag && initLoadEnd && res_productList.length === 0">
                <div class="pageContent--noResult">
                    <div class="noResult">
                        <p class="noResult-msg">
                            抱歉！没有找到与“<span>{{ QS_keyword }}</span>”相关的商品
                        </p>
                        <p class="noResult-text">
                            添加微信管家为您一对一寻货
                        </p>
                        <a class="noResult-btnCopy" href="#" @click.prevent="event_copyWXManage">点击复制管家微信号</a>
                    </div>
                    <div class="mod-like mt20">
                        <div class="mod-head">
                            猜你喜欢
                        </div>
                        <m-goodsList
                            v-bind="{
                                api: api_getRecommend,
                                data: {
                                    type: 'search',
                                    count: 40,
                                }
                            }"
                        ></m-goodsList>
                    </div>
                </div>
            </div>
            <div class="pageContent" v-else>
                <!-- <ul class="brand">
                    <li class="brand-item">
                        <p class="brand-row brand-name">
                            BALENCIGABALENCIGABALENCIGABALENCIGABALENCIGABALENCIGABALENCIGABALENCIGABALENCIGABALENCIGABALENCIGABALENCIGABALENCIGABALENCIGABALENCIGABALENCIGA
                        </p>
                        <p class="brand-row brand-size">
                            在售商品200件
                        </p>
                        <span class="brand-enter">进入品牌</span>
                    </li>
                    <li class="brand-item">
                        <p class="brand-row brand-name">
                            BALENCIGA
                        </p>
                        <p class="brand-row brand-size">
                            在售商品200件
                        </p>
                        <span class="brand-enter">进入品牌</span>
                    </li>
                </ul> -->

                <div class="mod-list">
                    <ul class="listGoods" v-if="res_productList.length" ref="js_listGoods">
                        <li class="listGoods-item"
                            v-for="(row, index) in res_productList"
                            :key="index"
                        >
                            <a :href="'/proDetail_1217.html?prodId=' + row.productId" @click="dp_searchResultClick({
                                    key_word: QS_keyword,
                                    input_mode: QS_input_mode,
                                    class_id: req_data.categoryId,
                                    request_id: res_requestId,
                                    position: index,
                                    commodity_id: row.productId,
                                    commodity_name: row.productName,
                                    percommodity_price: row.secooPrice,
                                    commodity_brand: row.showBrand,
                                    price_tag: row.refTag,
                                    commodity_tag: '',
                                    property_tag: row.tags,
                                    sort_type: req_data.list_orderType[nowSingleIndex]['value'][0]['name'],
                                    isAd: row.isAd || false,
                                    adInfo: row.adInfo || {}
                                })">
                                <div class="listGoods-imgBox"
                                    :class="getRndBgColor()"
                                    :data-src="getImgSrcByIsWebpSupport(row.imgUrl, index)"
                                    :data-isad="row.isAd"
                                    :data-pmurl="row.adInfo && row.adInfo.pm && row.adInfo.pm[0].url"
                                    >
                                    <div class="listGoods-imgWrp"></div>
                                    <img v-if="row.mainActivityTag && res_activityTagInfo[row.mainActivityTag]" class="listGoods-activeIcon" :src="res_activityTagInfo[row.mainActivityTag].icon"  />
                                    <div class="listGoods-presell" v-if="row.preSaleDesc && row.preSaleDescInfo">
                                        <span class="listGoods-presellText">{{row.preSaleDesc}}</span>
                                        <span class="listGoods-presellMsg">{{row.preSaleDescInfo}}</span>
                                    </div>
                                    <p class="listGoods-sales"
                                        :class="{presell: row.preSaleDesc && row.preSaleDescInfo && row.promotionTags && row.promotionTags[0] }"
                                        v-if="row.promotionTags && row.promotionTags[0]"
                                        >{{row.promotionTags[0].tagName}}</p>
                                    <span v-if="row.isAd" class="listGoods-iconAd" :class="{hasPromotion: row.promotionTags && row.promotionTags[0]}">广告</span>
                                </div>
                                <div class="listGoods-info">
                                    <h3 class="listGoods-brand">{{ row.showBrand }}</h3>
                                    <p class="listGoods-name">
                                        {{ row.productName }}
                                    </p>
                                    <p class="listGoods-price">
                                        <template v-if="row.refPrice">
                                            <span class="listGoods-initPrice">￥{{ row.refPrice | getInt | formatNum }}{{ String(row.refPrice).split('.').length > 1 ? '.' : '' }}</span>
                                            <i class="listGoods-decimalPrice">{{ row.refPrice | getDecimal }}</i>
                                        </template>
                                        <template v-else>
                                            <span class="listGoods-initPrice">￥{{ row.secooPrice | getInt | formatNum }}{{ String(row.secooPrice).split('.').length > 1 ? '.' : '' }}</span>
                                            <i class="listGoods-decimalPrice">{{ row.secooPrice | getDecimal }}</i>
                                        </template>
                                        <span class="listGoods-priceLabel listGoods-vipLabel" v-if="row.refPriceType === 1"></span>
                                        <span class="listGoods-priceLabel listGoods-tagLabel" v-else-if="row.refTag">
                                            <em>{{ row.refTag }}</em>
                                        </span>
                                    </p>
                                    <p class="listGoods-pricing" :class="{'listGoods-isLine': row.isLine}" v-if="row.tipPrice">
                                        <span class="listGoods-tipPrice">￥{{ row.tipPrice | formatNum }}</span>
                                        <span class="listGoods-priceLabel listGoods-vipLabel" v-if="row.tipPriceType === 1"></span>
                                    </p>
                                    <!-- <p class="listGoods-labels" v-if="row.tags && row.tags.length">{{ row.tags | formatTags }}</p> -->
                                    <p class="listGoods-labels" v-if="row.tags && row.tags.length">
                                        <span :style="{visibility: 'hidden'}" v-for="(tag, tagIndex) in row.tags">{{ row.tags | tagsFormat(tagIndex) }}</span>
                                    </p>
                                </div>
                            </a>
                        </li>
                    </ul>
                    <p class="notFindedGoods" v-else>
                        抱歉，暂时没有找到符合条件的商品
                    </p>
                    <div class="loading" v-show="currPage !== 1 && loading">
                        <p>
                            <img src="../../../../common/img/loading_flower.gif" />正在努力加载中...
                        </p>
                    </div>
                    <div class="loadedAllEnd" v-show="currPage !== 1 && isLoadEnd">
                        <p>
                            没有更多商品了
                        </p>
                    </div>

                </div>
            </div>
            <transition name="fade">
                <div class="page-mask" v-show="isShowSortMenuMask" @click="event_hideSortMenu"></div>
            </transition>
        </div>

        <!-- 复杂筛选 -->
        <transition name="fade">
            <div class="page-slideMask page-mask" @click="event_hideComplexScreening" v-show="isShowComplexScreening"></div>
        </transition>
        <transition name="slide-left">
            <div class="page-slideContent" v-show="isShowComplexScreening">
                <div class="pagehead">
                    <div class="pagehead-title">筛选</div>
                    <a href="#" class="pagehead-btnBack" @click.prevent="event_hideComplexScreening">
                        <i class="iconfont icon-back"></i>
                    </a>
                    <a href="#" class="pagehead-btnSelect -pagehead-btnSelect--selected"
                        @click="event_resetComplexScreening"
                    >重置</a>
                </div>
                <div class="shai">
                    <div class="shaiItem"
                        :class="{
                            'shaiItem--hide': row.isHide
                        }"
                        v-for="(row, rowIndex) in res_filterList"
                    >
                        <div class="shaiItem-heading"
                            :class="{
                                'shaiItem-heading--nPr': rowIndex < 5 && (row.key !== 'price' || row.name !== '价格')
                            }"
                            @click="((row.key === 'price' || row.name === '价格') || rowIndex >= 5) && (row.isHide = !row.isHide)"
                        >
                            <div class="shaiItem-hd">
                                <span class="shaiItem-title">{{ row.name }}</span>
                                <span class="shaiItem-selectedText" v-if="(row.key !== 'price' || row.name !== '价格')">{{ getTmpSelectedMenuName(row, false) }}</span>
                            </div>
                            <span class="shaiItem-arrowTipBox"
                                :class="{
                                    'down': row.isHide,
                                    'up': !row.isHide
                                }"
                                v-if="(row.key === 'price' || row.name === '价格') || rowIndex >= 5"
                            >
                                <i class="arrowTip"></i>
                            </span>
                        </div>
                        <ul class="shaiItem-priceMenu" v-if="row.key === 'price' || row.name === '价格'">
                            <li class="priceIptBox">
                                <input class="priceInput" type="number" v-model="req_data.tmp_key__minPrice" @input="event_priceInputInput($event.target, 'minPrice')" @blur="event_priceInputBlur(row.key)" pattern="[0-9]*" placeholder="最低价" />
                            </li>
                            <li class="priceLine"></li>
                            <li class="priceIptBox">
                                <input class="priceInput" type="number" v-model="req_data.tmp_key__maxPrice" @input="event_priceInputInput($event.target, 'maxPrice')" @blur="event_priceInputBlur(row.key)" pattern="[0-9]*" placeholder="最高价" />
                            </li>
                        </ul>
                        <ul class="shaiItem-menu"
                            :class="{
                                'shaiItem-menu--price': (row.key === 'price' || row.name === '价格'),
                                'shaiItem-menu--brands': (row.key === 'price' || row.name === '价格') || (row.key === 'brandId' || row.name === '品牌')
                            }"
                            >
                            <template
                                v-for="(item, index) in row.value"
                                v-if="row.key !== 'categoryId' && row.key !== 'brandId'"
                            >
                                <li v-if="rowIndex === 0 && row.multiple === 0 && row.type === 1 && row.value.length === 1"
                                    :class="{
                                        selected: isTmpSelectedMenu(item.key, item.value[0].id)
                                    }"
                                    @click="event_selectedItem(item.key, item, item.multiple === 0, rowIndex, index, false)"
                                >
                                    <span>{{ item.name }}</span>
                                </li>
                                <li v-else
                                    :class="{
                                        selected: isTmpSelectedMenu(row.key, item.id)
                                    }"
                                    @click="event_selectedItem(row.key, item, row.multiple === 0, rowIndex, index, false)"
                                >
                                    <span>{{ item.name }}</span>
                                </li>
                            </template>
                            <template v-else-if="row.key === 'categoryId' && index <= 8">
                                <li
                                    :class="{
                                        selected: new RegExp('^' + item.id).test(req_data['tmp_key__' + row.key])
                                    }"
                                    v-if="index <= 7"
                                    @click="event_showAllCategory(row.key,  index)"
                                >
                                    <span>{{ item.name }}</span>
                                </li>
                                <li v-else class="all" @click="event_showAllCategory(row.key, 0)">
                                    <span>全部分类</span><i class="arrowTip right"></i>
                                </li>
                            </template>
                            <template v-else-if="row.key === 'brandId' && index <= 8">
                                <li
                                    :class="{
                                        selected: isTmpSelectedMenu(row.key, item.id)
                                    }"
                                    v-if="index <= 7"
                                    @click="event_selectedItem(row.key, item, row.multiple === 0, rowIndex, index, false)"
                                >
                                    <span>{{ item.name }}</span>
                                </li>
                                <li v-else class="all" @click="event_showAllBrand(row.key)">
                                    <span>全部品牌</span><i class="arrowTip right"></i>
                                </li>
                            </template>
                        </ul>
                    </div>
                    <!-- <div class="shaiItem">
                        <div class="shaiItem-hd">
                            <span class="shaiItem-title">分类</span>
                            <span class="shaiItem-selectedText"></span>
                            <span class="shaiItem-arrowTipUp">
                                <i class="arrowTip"></i>
                            </span>
                        </div>
                        <ul class="shaiItem-menu">
                            <li>
                                <span>会员日</span>
                            </li>
                            <li>
                                <span>包税</span>
                            </li>
                            <li>
                                <span>会员日</span>
                            </li>
                            <li>
                                <span>会员日</span>
                            </li>
                            <li>
                                <span>包税</span>
                            </li>
                            <li>
                                <span>会员日</span>
                            </li>
                            <li>
                                <span>包税</span>
                            </li>
                            <li>
                                <span>会员日</span>
                            </li>
                            <li class="all" @click="event_showCategory">
                                <span>全部分类</span><i class="arrowTip right"></i>
                            </li>
                        </ul>
                    </div>
                    <div class="shaiItem">
                        <div class="shaiItem-hd">
                            <span class="shaiItem-title">价格</span>
                            <span class="shaiItem-selectedText"></span>
                            <span class="shaiItem-arrowTipUp">
                                <i class="arrowTip"></i>
                            </span>
                        </div>
                        <ul class="shaiItem-priceMenu">
                            <li class="priceIptBox">
                                <input class="priceInput" type="number" pattern="[0-9]*" placeholder="最低价" />
                            </li>
                            <li class="priceLine"></li>
                            <li class="priceIptBox">
                                <input class="priceInput" type="number" pattern="[0-9]*" placeholder="最高价" />
                            </li>
                        </ul>
                        <ul class="shaiItem-menu shaiItem-menu--brands">
                            <li>
                                <span>会员日</span>
                            </li>
                            <li>
                                <span>包税</span>
                            </li>
                            <li>
                                <span>会员日</span>
                            </li>
                            <li>
                                <span>包税</span>
                            </li>
                            <li>
                                <span>会员日</span>
                            </li>
                            <li>
                                <span>包税</span>
                            </li>
                        </ul>
                    </div>
                    <div class="shaiItem">
                        <div class="shaiItem-hd">
                            <span class="shaiItem-title">品牌</span>
                            <span class="shaiItem-selectedText"></span>
                            <span class="shaiItem-arrowTipUp">
                                <i class="arrowTip"></i>
                            </span>
                        </div>
                        <ul class="shaiItem-menu shaiItem-menu--brands">
                            <li>
                                <span>会员日</span>
                            </li>
                            <li>
                                <span>包税</span>
                            </li>
                            <li>
                                <span>会员日</span>
                            </li>
                            <li>
                                <span>会员日</span>
                            </li>
                            <li>
                                <span>包税</span>
                            </li>
                            <li>
                                <span>会员日</span>
                            </li>
                            <li>
                                <span>包税</span>
                            </li>
                            <li>
                                <span>会员日</span>
                            </li>
                            <li class="all" @click="event_showBrands">
                                <span>全部品牌</span><i class="arrowTip right"></i>
                            </li>
                        </ul>
                    </div> -->
                </div>
                <div class="menu-btns"><a href="#" style="width: 100%;" @click="event_submitComplexScreening">确定</a>
                </div>
            </div>
        </transition>

        <!-- 分类筛选 -->
        <transition name="fade">
            <div class="page-slideMask page--transparent" v-show="isShowAllCategory" @click.prevent="event_hideAllCategory"></div>
        </transition>
        <transition name="slide-left">
            <div class="page-slideContent page--category" v-show="isShowAllCategory">
                <div class="pagehead">
                    <div class="pagehead-title">分类</div>
                    <a href="#" class="pagehead-btnBack" @click.prevent="event_hideAllCategory"><i class="iconfont icon-back"></i></a>
                </div>
                <div class="shai"
                    v-for="(row, rowIndex) in res_filterList"
                    v-if="row.key === 'categoryId' || row.name === '分类'"
                >
                    <div class="shaiItem"
                        :class="{
                             'shaiItem--hide': item.isHide
                        }"
                        v-for="(item, index) in row.value"
                    >
                        <div class="shaiItem-heading"
                            @click="item.isHide = !item.isHide"
                        >
                            <div class="shaiItem-hd">
                                <span class="shaiItem-title">{{ item.name }}</span>
                            </div>
                            <span class="shaiItem-arrowTipBox"
                                :class="{
                                    'down': item.isHide,
                                    'up': !item.isHide
                                }"
                            >
                                <i class="arrowTip"></i>
                            </span>
                        </div>
                        <ul class="shaiItem-menu">
                            <li
                                :class="{
                                    'selected': req_data['tmp_key__' + row.key] === childItem.id
                                }"
                                v-for="(childItem, index) in item.child"
                                @click="event_selectedItem(row.key, childItem, row.multiple === 0, rowIndex, index, false, true)"
                            >
                                <span>{{ childItem.name }}</span>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </transition>

        <!-- 品牌筛选 -->
        <transition name="fade">
            <div class="page-slideMask page--transparent" v-show="isShowAllBrand" @click="event_hideAllBrand"></div>
        </transition>
        <transition name="slide-left">
            <div class="page-slideContent" v-show="isShowAllBrand">
                <div class="pagehead">
                    <div class="pagehead-title">品牌</div>
                    <a href="#" class="pagehead-btnBack" @click.prevent="event_hideAllBrand">
                        <i class="iconfont icon-back"></i>
                    </a>
                    <a href="#" class="pagehead-btnSelect -pagehead-btnSelect--selected"
                        @click.prevent="event_resetAllBrand"
                    >重置</a>
                </div>
                <ul class="brandlist-selected" style="display: none;">
                    <li class="brandlist-selectedItem">
                        <span>Australia Luxe Collective</span>
                        <i class="iconfont icon-close"></i>
                    </li>
                    <li class="brandlist-selectedItem">
                        <span>cozy steps</span>
                        <i class="iconfont icon-close"></i>
                    </li>
                    <li class="brandlist-selectedItem">
                        <span>Australia Luxe Collective</span>
                        <i class="iconfont icon-close"></i>
                    </li>
                    <li class="brandlist-selectedItem">
                        <span>cozy steps</span>
                        <i class="iconfont icon-close"></i>
                    </li>
                    <li class="brandlist-selectedItem">
                        <span>Australia Luxe Collective</span>
                        <i class="iconfont icon-close"></i>
                    </li>
                    <li class="brandlist-selectedItem">
                        <span>cozy steps</span>
                        <i class="iconfont icon-close"></i>
                    </li>
                </ul>
                <div class="brandlist-container">
                    <div class="brandlist-box">
                        <div class="brandlist">
                            <h3 class="brandlist-itemTitle" style="display: none;">A</h3>
                            <ul class="brandlist-itemContent"
                                v-for="(row, rowIndex) in res_filterList"
                                v-if="row.key === 'brandId' || row.name === '品牌'"
                            >
                                <li class="brandlist-item"
                                    :class="{
                                        selected: req_data['tmp2_key__' + row.key].indexOf(item.id) >= 0
                                    }"
                                    v-for="(item, index) in row.value"
                                    @click="event_selectedItem(row.key, item, row.multiple === 0, rowIndex, index, false, true)"
                                >
                                    <span>{{ item.name }}</span>
                                    <i class="iconfont icon-selected"></i>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <ul class="brandKeys" style="display: none;">
                        <li class="active"><span>A</span>
                        </li>
                        <li><span>B</span>
                        </li>
                        <li><span>C</span>
                        </li>
                        <li><span>D</span>
                        </li>
                        <li><span>E</span>
                        </li>
                        <li><span>F</span>
                        </li>
                        <li><span>G</span>
                        </li>
                        <li><span>H</span>
                        </li>
                        <li><span>I</span>
                        </li>
                        <li><span>J</span>
                        </li>
                        <li><span>K</span>
                        </li>
                        <li><span>L</span>
                        </li>
                        <li><span>M</span>
                        </li>
                        <li><span>N</span>
                        </li>
                        <li><span>O</span>
                        </li>
                        <li><span>P</span>
                        </li>
                        <li><span>Q</span>
                        </li>
                        <li><span>R</span>
                        </li>
                        <li><span>S</span>
                        </li>
                        <li><span>T</span>
                        </li>
                        <li><span>U</span>
                        </li>
                        <li><span>V</span>
                        </li>
                        <li><span>W</span>
                        </li>
                        <li><span>X</span>
                        </li>
                        <li><span>Y</span>
                        </li>
                        <li><span>Z</span>
                        </li>
                    </ul>
                </div>
                <div class="menu-btns">
                    <a href="#" style="width: 100%;" @click.prevent="event_submitAllBrand">确定</a>
                </div>
            </div>
        </transition>

        <!-- 提示弹层 -->
        <transition name="fade">
            <div class="panel panel-box" v-show="isShowLimitWarning">
                <p class="panel-warning">
                    <transition name="slide-up">
                        <span v-show="isShowLimitWarning">最多选择5项</span>
                    </transition>
                </p>
            </div>
        </transition>
        <!-- alert提示 -->
        <m-dialog
            v-bind="{
                model: 'alert',
                btnTrueText: '确定',
                isShow: isShowWXManageDialog
            }"
            @emit_ok="emit_closeWXManageDialog"
        >
            <p class="longPress-title">请长按复制</p>
            <p class="longPress-content">secoo66</p>
        </m-dialog>
        <m-search
            v-bind="{
                searchKeyword: QS_keyword,
                from: 'search_list',
                isPageList: true
            }"
            v-if="isShowPanelSearch"
            @emit_closePanelSearch="emit_hidePanelSearch"
        ></m-search>
    </div>
</template>
<script>
//引入组件
import MDialog from '@/components/MDialog';
import MGoodsList from '@/components/MGoodsList';
import MSearch from '@/components/MSearch';

//引入JS
import { mapMutations, mapActions } from 'vuex';
let SEC = require('common/js/utils/core.js');

//引入配置
import {
    getLocationSearch,
    getImgSrcByIsWebpSupport // 根据是否支持图片模式webp，计算图片地址
} from '@/public/js/public.js';
import {
    COOKIE_MAX_AGE,
    COOKIE_HOST_DOMAIN
} from '@/config';

//引入API接口
import {
    api_getSearchKeyword, //搜索列表-关键词搜索
    api_getSearchCategory, //搜索列表-分类搜索
    api_getSearchBrand, //搜索列表-品牌搜索
    api_getSearchTicket, //搜索列表-优惠券搜索
    api_getRecommend, //猜你喜欢
} from '@/api';


function myTest () {
    alert('myTest');
}

export default {
    name: "",
    data: () => ({
        //device_id: 'BA9EE208-A865-4E91-8DEF-27398327CA60', //设备id
        device_id: SEC.cookie.get('ST_FPC') && SEC.cookie.get('ST_FPC').split(':')[0].substring(3), //设备id
        platform_type: 0, //平台类型
        app_ver: '7.5.1', //版本号


        QS_type: '', //页面类型
        QS_keyword: '', //查询内容
        QS_categoryId: '', //分类ID
        QS_brandId: '', //品牌ID
        QS_ticketId: '', //优惠券ID
        QS_from: '', //跳转至列表页的来源
        QS_input_mode: 'input_mode', // 输入方式 -> 打点用
        QS_opt_params: '', // 其他可选参数；配合keyword一起使用；如果存在，则将其值一块作为参数，再调用接口进行关键词搜索

        api_getRecommend, //猜你喜欢

        // 是否支持图片webp格式
        isWebpSupport: (localStorage.getItem('isWebpSupport') ? true : false),

        isToUp: false, //是否收起顶部导航菜单
        isShowSortMenuMask: false, //是否显示下拉菜单遮照
        isShowWXManageDialog: false, //是否显示微信管家号
        isShowSortMenuFull: false, //是否显示全屏菜单
        isShowComplexScreening: false, //是否显示复杂筛选
        isShowAllBrand: false,    //是否显示全部品牌筛选面板
        isShowAllCategory: false, //是否显示全部分类筛选面板
        isAddPageHidden: false, //是否禁用页面滚动
        isShowLimitWarning: false, //是否显示多选限制警告提醒
        isShowPanelSearch: false, //是否显示搜索面板

        // 打点统计的事件名称，现用-神策
        doPointEvents: [
            'SearchResultClick', // 事件名：搜索后点击
        ],

        initLoadFlag: true, //初始加载
        initLoadEnd: false, //非初次加载
        loading: true, //加载状态
        isLoadSuccess: true, //是否请求加载成功
        isLoadEnd: false, //全部加载完毕
        currPage: 1, //当前面码
        maxPage: -1, //最大页数

        nowSingleIndex: 0, //当前单选的索引值
        //当前下拉菜单
        currentSortMenu: {
            key: '',
            isShow: false
        },

        //当前筛选条件及请求所需数据==================================
        req_data: {}, //请求数据
        res_sortList: [], //固定筛选
        res_filteroutlist: [], //简单筛选
        res_filterList: [], //复杂筛选

        //暂存区-初始筛选条件及请求所需数据的暂存区==================================
        // tmp_data: {}, //请求数据
        // tmp_sortList: [], //固定筛选
        // tmp_filteroutlist: [], //简单筛选
        // tmp_filterList: [], //复杂筛选

        //====================================================================
        res_activityTagInfo: {}, // 活动标签内容, 主要用来显示左上角角标
        res_productList: [], //商品列表
        res_wecharManage: [] //微信管家
    }),
    computed: {
        getAPI(){
            switch(this.QS_type){
                case 'category':
                    return api_getSearchCategory;
                case 'brand':
                    return api_getSearchBrand;
                case 'ticket':
                    return api_getSearchTicket;
                default:
                    return api_getSearchKeyword
            }
        }
    },
    created(){
        this.initQS(); //初始化获取url参数列表
        this.initLoad(); //初始加载
    },
    updated() {
        // 计算显示合适标签组
        this.computedShowListGoodsLabels();
    },
    methods: {
        // 计算显示合适标签组
        computedShowListGoodsLabels() {
            let oListGoods = this.$refs.js_listGoods;
            if (oListGoods) {

                let aLiItems = oListGoods.querySelectorAll('.listGoods-item');
                let oListGoodsBrand = oListGoods.querySelector('.listGoods-brand');
                let boxWidth = Math.floor(oListGoodsBrand.offsetWidth);

                aLiItems.forEach(oLiItem => {
                    let oLabel = oLiItem.querySelector('.listGoods-labels');
                    if (oLabel) {
                        let aSpan = oLabel.querySelectorAll('span');
                        let len = aSpan.length;
                        let isTrue = false; // 标识位，是否找到符合条件的元素

                        for (let i = 0; i < len; i++) {
                            let oSpan = aSpan[i];
                            let spanWidth = oSpan.offsetWidth;

                            // 找到符合条件的选项后，让其显示（找到第一个符合条件的选项后，不再查找别的）其它直接删除；
                            if (spanWidth < boxWidth && !isTrue) {
                                oSpan.style.visibility = 'visible';
                                isTrue = true;
                            } else {
                                oSpan.parentNode.removeChild(oSpan);
                            }
                        }
                    }
                });
            }
        },

        //初始化获取url参数列表
        initQS(){
            let params = [
                    'type', //页面类型
                    'keyword', //查询内容
                    'categoryId', //分类ID
                    'brandId', //品牌ID
                    'ticketId', //优惠券ID
                    'from', //跳转至列表页的来源
                    'input_mode', // 输入方式 -> 打点用
                    'opt_params' // 其实关键词搜索的可选参数
                ];
            SEC.string.get_urlParams(params, this);
            this.QS_search = getLocationSearch();

            switch(this.QS_type){
                case 'ticket':
                    this.QS_keyword = '用券专区';
                    break;
            }
        },

        // 根据是否支持图片模式webp，计算图片地址
        getImgSrcByIsWebpSupport,

        //初始化数据
        initData(){
            this.isToUp = false; //是否收起顶部导航菜单
            this.isShowSortMenuMask = false; //是否显示下拉菜单遮照
            this.isShowWXManageDialog = false; //是否显示微信管家号
            this.isShowSortMenuFull = false; //是否显示全屏菜单
            this.isShowComplexScreening = false; //是否显示复杂筛选
            this.isShowAllBrand = false;    //是否显示全部品牌筛选面板
            this.isShowAllCategory = false; //是否显示全部分类筛选面板
            this.isAddPageHidden = false; //是否禁用页面滚动
            this.isShowLimitWarning = false; //是否显示多选限制警告提醒
            this.isShowPanelSearch = false; //是否显示搜索面板

            this.initLoadFlag = true; //初始加载
            this.initLoadEnd = false; //非初次加载
            this.loading = true; //加载状态
            this.isLoadSuccess = true; //是否请求加载成功
            this.isLoadEnd = false; //全部加载完毕
            this.currPage = 1; //当前面码
            this.maxPage = -1; //最大页数

            this.nowSingleIndex = 0; //当前单选的索引值
            //当前下拉菜单
            this.currentSortMenu = {
                key: '',
                isShow: false
            };

            //当前筛选条件及请求所需数据==================================
            this.req_data = {}; //请求数据
            this.res_sortList = []; //固定筛选
            this.res_filteroutlist = []; //简单筛选
            this.res_filterList = []; //复杂筛选

            //====================================================================
            this.res_requestId = ''; // 当前请求ID
            this.res_productList = []; //商品列表
            this.res_wecharManage = []; //微信管家
            this.res_activityTagInfo = {}; // 活动标签内容, 主要用来显示左上角角标
        },

        //判断是否数组
        isArray(data){
            return Object.prototype.toString.call(data) === '[object Array]';
        },

        //获取计算后的样式
        getStyle(ele, attr){
            return ele.currentStyle ? ele.currentStyle[attr] : getComputedStyle(ele, false)[attr];
        },

        //获取视口大小
        getViewWH(){
            let doc = document.documentElement,
                body = document.body;
            return {
                W: doc.clientWidth || body.clientWidth,
                H: doc.clientHeight || body.clientHeight
            };
        },

        //获取随机背景色
        getRndBgColor(){
            let arr = ['rndBg0', 'rndBg1', 'rndBg2', 'rndBg3', 'rndBg4'],
                rndIndex = Math.floor( Math.random() * arr.length );
            //console.log(rndIndex, arr[rndIndex]);
            return [ arr[rndIndex] ];
        },

        //显示警告
        showWarning(){
            this.isShowLimitWarning = true;
            clearTimeout(document.timer);
            document.timer = setTimeout(() => {
                this.isShowLimitWarning = false;
                clearTimeout(document.timer);
                document.timer = null;
            }, 2000);
        },

        //显示搜索面板
        event_showPanelSearch(){
            this.isShowPanelSearch = true;
        },

        //隐藏搜索面板
        emit_hidePanelSearch(){
            this.isShowPanelSearch = false;
        },

        //获取已选择菜单的名称
        getSelectedMenuName(row, isSingle){
            let req_data = this.req_data,
                req_key = req_data[row.key],
                req_txt = req_data['txt__'+row.key];

            if(isSingle){ //单选
                if(row.showMenu){
                    return req_key ? req_txt : row.name;
                }else{
                    return row.name;
                }
            }else{ //多选
                if(this.isArray(req_key)){ //多选
                    let res = [],
                        tmp_arr = [ ...req_txt ];
                    //做了按排列菜单的一个排序
                    tmp_arr.sort((row1, row2) => {
                        return row1.index - row2.index;
                    });
                    for(let i = 0, len = tmp_arr.length; i < len; i++){
                        res.push(tmp_arr[i].name);
                    }
                    return req_key.length ? res.join('、') : row.name;
                }else{ //单选
                    // return req_key ? req_txt : row.name;
                    return row.name;
                }
            }
        },

        //获取临时已选择菜单的名称
        getTmpSelectedMenuName(row, isSingle){
            let req_data = this.req_data,
                tmp_key = req_data['tmp_key__' + row.key],
                tmp_txt = req_data['tmp_txt__' + row.key];

            if(isSingle){ //单选

            }else{ //多选
                if(this.isArray(tmp_key)){ //多选
                    let res = [],
                        tmp_arr = [ ...tmp_txt ];
                    //做了按排列菜单的一个排序
                    tmp_arr.sort((row1, row2) => {
                        return row1.index - row2.index;
                    });
                    for(let i = 0, len = tmp_arr.length; i < len; i++){
                        res.push(tmp_arr[i].name);
                    }
                    return tmp_key.length ? res.join('、') : '';
                }else{ //单选
                    return tmp_key ? tmp_txt : '';
                }
            }
        },

        //获取临时已选择菜单的名称
        isTmpSelectedMenu(key, id){
            let req_data = this.req_data,
                tmp_key = req_data['tmp_key__' + key];

            if(this.isArray(tmp_key)){
                return tmp_key.indexOf(id) !== -1;
            }else{
                return tmp_key === id;
            }
        },

        lazyLoad(){
            let aImgBox = document.querySelectorAll('.listGoods-imgBox[data-src]'),
                vH = document.documentElement.clientHeight || document.body.clientHeight,
                arrImgBox = [];

            for(let i=0, l=aImgBox.length; i<l; i++){
                arrImgBox.push(aImgBox[i]);
            }

            for(let i=0; i<arrImgBox.length; i++){
                let oImgBox = arrImgBox[i],
                    oImgWrp = oImgBox.querySelector('.listGoods-imgWrp'),
                    src = oImgBox.getAttribute('data-src'),
                    pos = oImgBox.getBoundingClientRect(),
                    top = pos.top,
                    bottom = pos.bottom;
                let isAd = oImgBox.dataset.isad === 'true' ? true : false;
                let pmUrl = oImgBox.dataset.pmurl || '';

                //console.log(top, bottom);
                if(top < vH && bottom > 0){ //在可视区内
                    oImgWrp.innerHTML = `<img src="${ src }" style="display: block;" width="100%" height="100%" />`;
                    oImgBox.removeAttribute('data-src');
                    arrImgBox.splice(i, 1);
                    --i;

                    // 如果是广告的话，请求接口返回的曝光回调
                    if (isAd) {
                        let oImg = new Image();
                        oImg.src = pmUrl + '&=_' + Math.random();
                        oImgBox.removeAttribute('data-isad');
                        oImgBox.removeAttribute('data-pmurl');
                    }
                }
            }
        },

        //加载数据
        load(data, options){
            // brandId	      品牌ids	  string	多个id用_分隔,如: 3_4
            // categoryId	  分类组织码	string	如"_30_" 30为一级分类ID, "_30_31" 30为一级分类ID 31二级分类ID,"_30_31_32" 以此类推
            // currPage	      当前页	  number
            // discountTypeId 优惠类型id string	多个用_分隔。具体值服务端返回
            // keyword	      搜索关键字	string
            // orderType	  排序类型	 number	具体值服务端返回
            // pageSize	      每页数	 number	默认10条
            // price	      价格区间	 string	如: 0_1000表示0到1000之间,1000_表示1000以上
            // queryType	  查询类型默认为1	number	0只查询商品 1查询商品和筛选条件 2只查询筛选条件
            // searchMode	  搜索方式	 string	1文本 2语音
            // warehouseId	  发货地ID	 string	多个用_分隔,如 3_4。具体值服务端返回
            let __data = {};

            data = data || {};
            options = options || {};

            __data = {
                c_device_id: this.device_id,
                c_platform_type: this.platform_type,
                c_app_ver:	this.app_ver,
                deviceType: 'wap',
                queryType: 0, // 查询类型默认为1 number	0只查询商品 1查询商品和筛选条件 2只查询筛选条件
                searchMode: 1,
                currPage: options.currPage || this.currPage,  //当前页number
                pageSize: 10
            };

            //分类
            switch(this.QS_type){
                case 'category': //分类
                    __data.categoryId = this.QS_categoryId;
                    break;
                case 'brand': //品牌
                    __data.brandId = this.QS_brandId;
                    break;
                case 'ticket': //优惠券
                    __data.ticketId = this.QS_ticketId;
                    break;
                default:
                    __data.keyword = this.QS_keyword;  //搜索关键字	string
            }

            // 哪果有其它参数值时
            let opt_params = this.QS_opt_params;
            if (opt_params && /^\{[\s\S]*\}$/.test(opt_params)) {
                try {
                    Object.assign(data, JSON.parse(opt_params));
                } catch (e) {}
            }

            //重写新生
            for(let attr in data){
                __data[attr] = data[attr];
            }

            this.loading = true;
            this.isLoadEnd = false;
            this.getAPI(__data).then(
                res => {
                    let data = res.body || {},
                        sortList = this.isArray(data.sortList) ? data.sortList : [], //固定筛选
                        filteroutlist = this.isArray(data.filteroutlist) ? data.filteroutlist : [], //简单筛选
                        filterList = this.isArray(data.filterList) ? data.filterList : [], //复杂筛选
                        productList = this.isArray(data.productList) ? data.productList : [], //商品列表
                        wecharManage = data.wecharManage,
                        req_data = {},
                        secoo_tese = {
                            name: '独家推荐',
                            type: 1,
                            multiple: 0,
                            value: []
                        }, //寺库特色
                        secoo_filterList = [],
                        newFilterList = []; //微信管家

                    // data.productList[0].tags = [
                    //     {styleId: "2", name: "每满10万减500"},
                    //     {styleId: "2", name: "每满10万减500"},
                    //     {styleId: "2", name: "多件多折"},
                    //     {styleId: "2", name: "自营"}
                    // ];
                    // data.productList[1].tags = [
                    //     {styleId: "2", name: "满赠"},
                    //     {styleId: "2", name: "分期免息"},
                    //     {styleId: "2", name: "多件多折"},
                    //     {styleId: "2", name: "自营"}
                    // ];


                    if(__data.queryType == 1) // 1查询商品和筛选条件
                    {
                        // 综合排序
                        let singleItem0 = sortList[0];
                        if (singleItem0) {
                            //设置单选数据
                            let singleItem0_value0 = singleItem0.value[0];
                            req_data['tmp_key__'+singleItem0.key] = req_data[singleItem0.key] = singleItem0_value0.id;
                            req_data['txt__' + singleItem0.key] = singleItem0_value0.name;
                            req_data['list_' + singleItem0.key] = [];
                        }

                        sortList.map((item, index) => {
                            let key = item.key;
                            req_data['list_' + key][index] = {
                                key: key,
                                showMenu: item.showMenu,
                                value: [ item.value[0] ]
                            };
                        });


                        //设置筛选数据
                        filterList.map((item, index) => {
                            let key = item.key,
                                name = item.name,
                                multiple = item.multiple;

                            if(multiple){ //多选
                                req_data[key] = [];
                                req_data['txt__'      + key] = [];
                                req_data['tmp_key__'  + key] = [];
                                req_data['tmp_txt__'  + key] = [];
                                req_data['tmp2_key__' + key] = [];
                                req_data['tmp2_txt__' + key] = [];
                            }else{ //单选
                                req_data[key] = '';
                                req_data['txt__'      + key] = '';
                                req_data['tmp_key__'  + key] = '';
                                req_data['tmp_txt__'  + key] = '';
                                req_data['tmp2_key__' + key] = '';
                                req_data['tmp2_txt__' + key] = '';

                                if(key === 'price'){
                                    req_data['minPrice'] = '';
                                    req_data['maxPrice'] = '';
                                    req_data['tmp_key__minPrice'] = '';
                                    req_data['tmp_key__maxPrice'] = '';
                                }
                            }

                            if(key === 'brandId' || name === '品牌'){
                                item.value.sort((row1, row2) => {
                                    return row1.name.localeCompare(row2.name, 'zh');
                                });
                            }

                            // 独家推荐; 仅有一个标签时返回时，才执行
                            if(item.type === 1 && item.value && item.value.length === 1){
                                item.id = item.value[0].id;
                                secoo_tese.value.push(item);
                            }else{
                                secoo_filterList.push(item);
                            }
                        });

                        //对品牌进行按名称排序
                        filteroutlist.map(item => {
                            if(item.key === 'brandId' || item.name === '品牌' ){
                                item.value.sort((row1, row2) => {
                                    return row1.name.localeCompare(row2.name, 'zh');
                                });
                            }
                        });

                        //整理后的新复杂筛选项
                        newFilterList = secoo_tese.value.length ? [].concat(secoo_tese, secoo_filterList) : secoo_filterList;
                        // console.log(secoo_tese.value.length, newFilterList);


                        //添加默认显示、隐藏状态
                        newFilterList.map((item, index) => {
                            let key = item.key;
                            if((key === 'price' || name === '价格') || index >= 5){
                                item.isHide = true;
                            }else{
                                item.isHide = false;
                            }

                            if((key === 'categoryId' || name === '分类')){
                                item.value.map(item => {
                                    item.isHide = true;
                                });
                            }
                        });

                        this.res_filteroutlist = filteroutlist;//简单筛选
                        this.res_filterList = newFilterList; //复杂筛选
                        this.res_sortList = sortList; //固定筛选
                        this.res_wecharManage = wecharManage; //微信管家
                        this.res_activityTagInfo = data.activityTagInfo; // 活动标签内容, 主要用来显示左上角角标
                        this.res_requestId = data.requestId; // 请求ID
                        this.res_productList = productList; //商品列表

                        this.req_data = req_data;

                        //增加可用最大页码数据
                        this.maxPage = data.maxPage;
                        if(this.currPage >= this.maxPage){
                            this.isLoadEnd = true;
                        }

                        //初始加载完成
                        this.initLoadEnd = true;

                        //console.log(JSON.stringify(newFilterList));
                        //console.log(JSON.stringify(req_data));
                    }
                    else if(__data.queryType == 2) // 2只查询筛选条件 主要是针对分类筛选的
                    {
                        //设置筛选数据
                        filterList.map((item, index) => {
                            let key = item.key,
                                name = item.name,
                                multiple = item.multiple;

                            if(multiple){ //多选
                                req_data[key] = [];
                                req_data['txt__'      + key] = [];
                                req_data['tmp_key__'  + key] = [];
                                req_data['tmp_txt__'  + key] = [];
                                req_data['tmp2_key__' + key] = [];
                                req_data['tmp2_txt__' + key] = [];
                            }else{ //单选
                                req_data[key] = '';
                                req_data['txt__'      + key] = '';
                                req_data['tmp_key__'  + key] = '';
                                req_data['tmp_txt__'  + key] = '';
                                req_data['tmp2_key__' + key] = '';
                                req_data['tmp2_txt__' + key] = '';

                                if(key === 'price'){
                                    req_data['minPrice'] = '';
                                    req_data['maxPrice'] = '';
                                    req_data['tmp_key__minPrice'] = '';
                                    req_data['tmp_key__maxPrice'] = '';
                                }
                            }

                            if(key === 'categoryId' || name === '分类'){
                                let res_filterList = this.res_filterList;
                                for(let i=0, l=res_filterList.length; i<l; i++){
                                    let filterItem = res_filterList[i];
                                    if(filterItem.key === key){
                                        item.value = JSON.parse(JSON.stringify(filterItem.value));
                                    }
                                }
                            }

                            //对品牌进行按名称排序
                            if(key === 'brandId' || name === '品牌'){
                                item.value.sort((row1, row2) => {
                                    return row1.name.localeCompare(row2.name, 'zh');
                                });
                            }

                            // 独家推荐; 仅有一个标签时返回时，才执行
                            if(item.type === 1 && item.value && item.value.length === 1){
                                item.id = item.value[0].id;
                                secoo_tese.value.push(item);
                            }else{
                                secoo_filterList.push(item);
                            }
                        });

                        //对品牌进行按名称排序
                        filteroutlist.map(item => {
                            if(item.key === 'brandId' || item.name === '品牌' ){
                                item.value.sort((row1, row2) => {
                                    return row1.name.localeCompare(row2.name, 'zh');
                                });
                            }
                        });

                        //整理后的新复杂筛选项
                        newFilterList = secoo_tese.value.length ? [].concat(secoo_tese, secoo_filterList) : secoo_filterList;

                        //添加默认显示、隐藏状态
                        newFilterList.map((item, index) => {
                            let key = item.key;
                            if((key === 'price' || name === '价格') || index >= 5){
                                item.isHide = true;
                            }else{
                                item.isHide = false;
                            }

                            if((key === 'categoryId' || name === '分类')){
                                item.value.map(item => {
                                    item.isHide = true;
                                });
                            }
                        });

                        //复制固定排序及分类
                        for(let attr in this.req_data){
                            if(/orderType$/.test(attr)){
                                req_data[attr] = this.req_data[attr];
                            }else if(/categoryId$/.test(attr)){
                                if(__data.categoryId){
                                    req_data[attr] = this.req_data[attr];
                                }
                            }
                        }

                        if(options.fnSuccess){
                            options.fnSuccess(filteroutlist, newFilterList, req_data);
                        }else{
                            //设置新的筛选条件
                            this.setNewFilterData(filteroutlist, newFilterList, req_data);
                        }

                        //console.log(JSON.stringify(newFilterList));
                        //console.log(JSON.stringify(req_data));
                    }
                    else // 0只查询商品
                    {
                        if(this.currPage === 1){ //第一页数据
                            if(options.fnSuccess){
                                options.fnSuccess(productList);
                            }else{
                                this.res_productList = productList; //商品列表
                            }
                        }else{
                            this.res_productList = this.res_productList.concat(productList); //商品列表
                        }

                        this.res_requestId = data.requestId; // 请求ID

                        //增加可用最大页码数据
                        this.maxPage = data.maxPage;
                        if(this.currPage >= this.maxPage){
                            this.isLoadEnd = true;
                        }
                    }
                    //加载完成
                    this.loading = false;
                    this.isLoadSuccess = true; //请求加载成功
                    //console.log(data);
                },
                error => {
                    this.loading = false; //加载完成
                    this.isLoadSuccess = false; //请求加载失败
                    this.show_alert({
                        content: '亲，您的网络不给力吆'
                    });
                }
            ).then(() => {
                this.$nextTick(() => {
                    this.lazyLoad();
                });
            });
        },

        //设置新的筛选条件
        setNewFilterData(filteroutlist, newFilterList, req_data){
            this.res_filteroutlist = filteroutlist;//简单筛选
            this.res_filterList = newFilterList; //复杂筛选
            this.req_data = req_data;
        },

        //设置商品数据
        setProductList(productList){
            this.res_productList = productList; //商品列表
        },

        //初始加载
        initLoad(){
            this.load(
                {
                    queryType: 1 //1查询商品和筛选条件
                }
            );
        },

        //通用加载
        commLoad(data, options){
            let oPage = this.$refs.page;

            data = data || {};
            options = options || {};

            //初次加载成功，才可以进行后续加载数据
            if(!this.initLoadEnd){ return;}
            this.initLoadFlag = false; //设置标识为非初次加载

            //当前页码
            if(options.currPage){
                this.currPage = options.currPage;
            }else{
                oPage.scrollTop = 0;
                this.isToUp = false;
                this.currPage = 1;
            }

            //data = this.getRealReqData(); //获取真实请求所需数据

            this.load(data, options);
        },

        //筛选条件加载，用于变更新的筛选条件
        filterLoad(data, options){
            data = data || {};
            options = options || {};

            this.initLoadFlag = false; //设置标识为非初次加载

            this.load(data, options);
        },

        //检测是否已有选中数据
        isHasSelectedMenu(){
            let req_data = this.req_data,
                data = {};

            for(let attr in req_data){
                if(!/^(tmp_|tmp2_|txt__|list_|minPrice|maxPrice|orderType)/.test(attr)){
                    let value = req_data[attr];
                    if(this.isArray(value)){
                        if(value.length){
                            return true;
                        }
                    }else{
                        if(value){
                            return true;
                        }
                    }
                }
            }
            return false;
        },

        //获取真实请求所需数据
        getRealReqData(){
            let req_data = this.req_data,
                data = {};

            for(let attr in req_data){
                if(!/^(tmp_|tmp2_|txt__|list_|minPrice|maxPrice)/.test(attr)){
                    let value = req_data[attr];
                    if(this.isArray(value)){
                        if(value.length){
                            data[attr] = value.join('_');
                        }
                    }else{
                        if(value){
                            data[attr]= value;
                        }
                    }
                }
            }

            // console.log('RealData--------------------');
            // console.log(JSON.stringify(data));
            // console.log('--------------------');

            return data;
        },

        //获取临时请求所需数据
        getTmpReqData(){
            let req_data = this.req_data,
                tmp_data = {};

            for(let attr in req_data){
                if(/^(tmp_key__(?!minPrice|maxPrice))/.test(attr)){
                    let value = req_data[attr];
                    if(this.isArray(value)){
                        if(value.length){
                            tmp_data[attr.replace('tmp_key__', '')] = value.join('_');
                        }
                    }else{
                        if(value){
                            tmp_data[attr.replace('tmp_key__', '')]= value;
                        }
                    }
                }
            }

            // console.log('tmp_data--------------------');
            // console.log(JSON.stringify(tmp_data));
            // console.log('--------------------');

            return tmp_data;
        },

        //监听页面滚动
        event_pageScroll(ev){
            if(this.res_productList.length){
                this.scrollMoveHead(ev); //滚动运动顶部导航
                this.scrollLoadMore(ev); //滚动加载更多数据
            }
            this.lazyLoad();
        },

        //滚动定位头部导航
        scrollMoveHead(ev){
            let target = ev.target,
                oPageHead = this.$refs.pageHead,
                oPHead = oPageHead.children[0],
                pH = oPHead.offsetHeight,
                pT= parseInt(this.getStyle(oPHead, 'paddingTop')),
                cha = pH - pT,
                sTop = target.scrollTop,
                __sTop = target.__sTop || 0;


            if(sTop < cha){
                if(navigator.userAgent.match(/(?:UCWEB|UCBrowser\/)([\d\.]+)/)){
                    this.isToUp = false;
                }
                return;
            }

            if(sTop > __sTop){ //下滑
                if(this.isToUp === false){
                    this.isToUp = true;
                }
            }else{ //上滑
                if(this.isToUp){
                    this.isToUp = false;
                }
            }
            target.__sTop = sTop;
        },

        //滚动定位菜单
        scrollFixedMenu(ev){
            let target = ev.target,
                oPageHead = target.children[0],
                oSortWrap = this.$refs.sortWrap,
                oSortBox,
                sT = target.scrollTop,
                pH = oPageHead.offsetHeight,
                pPB= parseInt(this.getStyle(oPageHead, 'paddingTop'));

            if(!oSortWrap){ return;}
            oSortBox = oSortWrap.children[0];
            if(sT >= pH - pPB){
                if(!oSortWrap.style.cssText){
                    oSortWrap.style.cssText = 'position: fixed; top: 0;';
                    oSortBox.style.cssText = 'padding: 0.26667rem 0';
                }
            }else{
                oSortWrap.style.cssText = '';
                oSortBox.style.cssText = '';
            }
        },

        //滚动加载更多数据
        scrollLoadMore(ev){
            let target = ev.target,
                sT = target.scrollTop,
                cntH = target.scrollHeight,
                vH = this.getViewWH().H,
                SPACE = 300;

            //console.log(sT, cntH, vH);

            if(sT + vH >= cntH - SPACE){
                if(!this.loading){
                    if(!target.sTimer){
                        target.sTimer = setTimeout(() => {
                            clearTimeout(target.sTimer);
                            target.sTimer = null;
                            //console.log(this.currPage,  this.maxPage, this.currPage <= this.maxPage);
                            if(this.isLoadSuccess){
                                this.currPage++;
                            }

                            if(this.currPage <= this.maxPage){
                                this.commLoad(
                                    this.getRealReqData(),
                                    {
                                        currPage: this.currPage
                                    }
                                );
                            }
                        }, 500);
                    }
                }
            }
        },

        //切换下拉菜单
        event_toggleDropdownMenu(ev, index, row, isShowMenu, isSingle){
            let currentTarget = ev.currentTarget,
                oPagehead = this.$refs.pagehead,
                oSortWrap = this.$refs.sortWrap,
                oSort = oSortWrap.children[0].children[0],
                oCurrentSortMenu,
                key = row.key,
                name = row.name,
                currentSortMenu = this.currentSortMenu,
                pH = oPagehead.offsetHeight,
                swH = oSortWrap.offsetHeight,
                vH = this.getViewWH().H,
                cntH,
                cha,
                req_data = this.req_data;

            if(isSingle){
                key = key + index;
            }

            //滚动菜单到中间位置
            this.scrollMenuToCenter(currentTarget, oSort);

            //固定筛选---点击非当前单选时
            // if(isSingle && index !== this.nowSingleIndex){
            //     let value0 = row.value[0];
            //     req_data[key] = value0.id;
            //     this.nowSingleIndex = index;
            //     this.hideSortMenu();
            //
            //     console.log(JSON.stringify(req_data));
            //     return;
            // }

            if(isShowMenu){ //是否显示下拉菜单
                //console.log(index !== this.nowSingleIndex, isSingle && index !== this.nowSingleIndex);
                if(isSingle && index !== this.nowSingleIndex){
                    let tmp_data = {};
                    this.nowSingleIndex = index;

                    req_data['tmp_key__' + row.key] = row.value[0].id;
                    tmp_data = this.getTmpReqData(); //获取临时数据

                    //通用加载
                    this.commLoad(
                        tmp_data,
                        {
                            fnSuccess: (productList) => {
                                req_data[row.key] = row.value[0].id;

                                //设置商品数据
                                this.setProductList(productList);
                                this.hideSortMenu();
                            }
                        }
                    );
                    //console.log(JSON.stringify(req_data));
                    return;
                }

                if(key === currentSortMenu.key){
                    if(currentSortMenu.isShow){
                        this.hideSortMenu();
                    }else{
                        this.showSortMenu(isSingle, key);
                    }
                }else{
                    currentSortMenu.key = key;
                    this.showSortMenu(isSingle, key);
                }

                //计算下拉菜单的高度
                this.$nextTick(() => {
                    oCurrentSortMenu = this.$refs[key][0];
                    cntH = oCurrentSortMenu.children[0].scrollHeight;

                    if(oSortWrap.style.position === 'fixed'){
                        oCurrentSortMenu.style.paddingTop = 0;
                        cha = vH - swH;
                    }else{
                        oCurrentSortMenu.style.paddingTop = '';
                        cha = vH - pH - swH;
                    }
                    //console.log(oCurrentSortMenu);
                    //console.log(pH, swH, vH, cha, cntH);
                    if(cntH >= cha){
                        oCurrentSortMenu.style.height = (cha + 1) + 'px';
                        this.isShowSortMenuFull = true;
                    }else{
                        this.isShowSortMenuFull = false;
                    }
                });
            }else{
                if(isSingle){ //固定排序
                    //console.log(row.value[0].id);
                    let rowValue = row.value[0];
                    let rowId = rowValue.id || rowValue.group[0].id;
                    if(rowId !== req_data[row.key]){
                        let tmp_data = {};
                        this.nowSingleIndex = index;

                        req_data['tmp_key__' + row.key] = rowId;
                        tmp_data = this.getTmpReqData(); //获取临时数据

                        //通用加载
                        this.commLoad(
                            tmp_data,
                            {
                                fnSuccess: (productList) => {
                                    req_data[row.key] = rowId;

                                    //设置商品数据
                                    this.setProductList(productList);
                                    this.hideSortMenu();
                                }
                            }
                        );
                    }
                    this.hideSortMenu();
                }else{
                    //简单筛选----未有下拉时
                    let tmp_data = {},
                        value = req_data[key] ? '' : row.value[0].id;

                    req_data['tmp_key__' + key] = value;
                    tmp_data = this.getTmpReqData(); //获取临时数据

                    //通用加载
                    this.commLoad(
                        tmp_data,
                        {
                            fnSuccess: (productList) => {
                                req_data[key] = value;

                                //console.log(JSON.stringify(req_data));

                                //设置商品数据
                                this.setProductList(productList);
                                this.hideSortMenu();
                            }
                        }
                    );
                }
            }

            //console.log(JSON.stringify(req_data));
        },

        /**
         * 选中筛选项
         * @param  {[type]}  key      [当前筛选项的key]
         * @param  {[type]}  item     [当前点击菜单的数据]
         * @param  {Boolean} isSingle [是否单选]
         * @param  {[type]}  rowIndex [当前筛选项的index索引值]
         * @param  {[type]}  index    [当前选项的index索引值]
         * @param  {[type]}  isSort   [是否固定排序，而不是筛选]
         * @param  {[type]}  isSort   [是否点击全部全部展开的二级菜单]
         * @return {[type]}           [description]
         */
        event_selectedItem(key, item, isSingle, rowIndex, index, isSort, isAll){
            let id = item.id,
                name = item.name,
                req_data = this.req_data,
                tmp_key = 'tmp_key__' + key,
                tmp_txt = 'tmp_txt__' + key;

            //console.log(key, item, isSingle, rowIndex);

            if(isSingle){ //单选
                if(isSort){ //固定排序
                    if(id !== req_data[key]){ //点击相同时不请求数据
                        let tmp_data = {};

                        req_data['tmp_key__' + key] = id;
                        tmp_data = this.getTmpReqData(); //获取临时数据

                        //通用加载
                        this.commLoad(
                            tmp_data,
                            {
                                fnSuccess: (productList) => {
                                    req_data[key] = id;
                                    req_data['txt__' + key] = name;
                                    req_data['list_' + key][rowIndex]['value'][0] = item; //更新当前列数据

                                    //设置商品数据
                                    this.setProductList(productList);
                                    this.hideSortMenu();
                                }
                            }
                        );
                    }
                    this.hideSortMenu(); //隐藏下拉菜单
                }else{
                    if(key === 'price'){
                        let arr;

                        req_data[tmp_key] = req_data[tmp_key] === id ? '' : id;
                        req_data[tmp_txt] = req_data[tmp_txt] === id ? '': name;

                        arr = req_data[tmp_key].split('_');
                        req_data.tmp_key__minPrice = arr[0];
                        req_data.tmp_key__maxPrice = arr[1] || '';
                    }else if(key === 'categoryId'){
                        //console.log(item, name);
                        let key = req_data[tmp_key] === id ? '' : id,
                            txt = req_data[tmp_txt] === name ? '' : name;

                        //重新查询筛选条件
                        this.filterLoad(
                            {
                                categoryId: key,
                                queryType: 2, //2只查询筛选条件
                                currPage: 1
                            },
                            {
                                fnSuccess: (filteroutlist, newFilterList, req_data) => {
                                    //设置新的筛选条件
                                    this.setNewFilterData(filteroutlist, newFilterList, req_data);
                                    req_data[tmp_key] = key;
                                    req_data[tmp_txt] = txt;
                                    this.hideAllCategory(); //关闭全部分类筛选
                                }
                            }
                        );
                    }else{
                        req_data[tmp_key] = req_data[tmp_key] ? '' : id;
                        req_data[tmp_txt] = req_data[tmp_txt] ? '': name;
                    }
                }
            }else{ //多选

                if(isAll){
                    if(key === 'brandId'){
                        let tmp2_key_value = req_data['tmp2_key__' + key],
                            tmp2_txt_value = req_data['tmp2_txt__' + key],
                            nowIndex = tmp2_key_value.indexOf(id);

                        if(nowIndex !== -1){
                            tmp2_key_value.splice(nowIndex, 1);
                            tmp2_txt_value.splice(nowIndex, 1);
                        }else{
                            if(tmp2_key_value.length >= 5){
                                this.showWarning(); //显示限制警告信息
                                return;
                            }
                            tmp2_key_value.push(id);
                            tmp2_txt_value.push({
                                index: index,
                                name: name
                            });
                        }
                    }
                }else{
                    let tmp_key_value = req_data[tmp_key],
                        tmp_txt_value = req_data[tmp_txt],
                        nowIndex = tmp_key_value.indexOf(id);

                    if(nowIndex !== -1){
                        tmp_key_value.splice(nowIndex, 1);
                        tmp_txt_value.splice(nowIndex, 1);
                    }else{
                        if(tmp_key_value.length >= 5){
                            this.showWarning(); //显示限制警告信息
                            return;
                        }
                        tmp_key_value.push(id);
                        tmp_txt_value.push({
                            index: index,
                            name: name
                        });
                    }
                }
            }
            //console.log(JSON.stringify(req_data));
        },

        //价格输入框失去焦点时
        event_priceInputBlur(key){
            let req_data = this.req_data,
                tmp_minPrice = req_data.tmp_key__minPrice,
                tmp_maxPrice = req_data.tmp_key__maxPrice,
                tmp_key = 'tmp_key__' + key;


            if(tmp_minPrice == 0){
                req_data.tmp_key__minPrice = tmp_minPrice = '';
            }
            if(tmp_maxPrice == 0){
                req_data.tmp_key__maxPrice = tmp_maxPrice = '';
            }

            if(tmp_minPrice !== '' && tmp_maxPrice !== ''){ //都不为空时
                req_data.tmp_key__minPrice = String( Math.min(parseInt(tmp_minPrice), parseInt(tmp_maxPrice)) );
                req_data.tmp_key__maxPrice = String( Math.max(parseInt(tmp_minPrice), parseInt(tmp_maxPrice)) );
            }else if(tmp_minPrice === '' && tmp_maxPrice !== ''){ //仅有最大值时
                req_data.tmp_key__minPrice = 0;
            }

            if(req_data.tmp_key__minPrice !== '' && req_data.tmp_key__maxPrice === ''){ //只有最小值时
                req_data[tmp_key] = req_data.tmp_key__minPrice + '_';
            }else{
                req_data[tmp_key] = req_data.tmp_key__minPrice + '_' + req_data.tmp_key__maxPrice;
            }
            //console.log(req_data[tmp_key]);
        },

         //监听输入事件
        event_priceInputInput(target, type){
            let req_data = this.req_data,
                tmp_key = 'tmp_key__' + type,
                price = req_data[tmp_key],
                tmp_price = price.replace(/[-\.]|[^0-9]/, '');

            req_data[tmp_key] = target.value = tmp_price;
            if(tmp_price.length >= 10){
                req_data[tmp_key] = tmp_price.substr(0, 10);
            }
        },

        //事件-隐藏下拉菜单
        event_hideSortMenu(){
            this.hideSortMenu();
        },

        //清空下拉菜单
        event_clearSortMenu(key){
            let tmp_data = {};
            this.req_data['tmp_key__' + key] = [];
            this.req_data['tmp_txt__' + key] = [];

            tmp_data = this.getTmpReqData(); //获取临时数据

            //通用加载
            this.commLoad(
                tmp_data,
                {
                    fnSuccess: (productList) => {
                        this.req_data[key] = [];
                        this.req_data['txt__' + key] = [];

                        //设置商品数据
                        this.setProductList(productList);
                        this.hideSortMenu();
                    }
                }
            );
        },

        //确定下拉菜单
        event_submitSortMenu(key){
            let req_data = this.req_data,
                tmp_key = req_data['tmp_key__' + key],
                tmp_txt = req_data['tmp_txt__' + key],
                tmp_data = {};

            tmp_data = this.getTmpReqData(); //获取临时数据

            //通用加载
            this.commLoad(
                tmp_data,
                {
                    fnSuccess: (productList) => {
                        this.req_data[key] = [ ...tmp_key ];
                        this.req_data['txt__' + key] = [ ...tmp_txt ];

                        //设置商品数据
                        this.setProductList(productList);
                        this.hideSortMenu();
                    }
                }
            );
            //console.log(JSON.stringify(req_data));
        },

        //显示下拉菜单
        showSortMenu(isSingle, key){
            if(!isSingle){
                this.req_data['tmp_key__' + key] = [ ...this.req_data[key] ];
                this.req_data['tmp_txt__' + key] = [ ...this.req_data['txt__' + key] ];
            }
            this.currentSortMenu.isShow = true;
            this.isShowSortMenuMask = true;
            this.isAddPageHidden = true;
        },

        //隐藏下拉菜单
        hideSortMenu(){
            this.currentSortMenu.isShow = false;
            this.isShowSortMenuMask = false;
            this.isAddPageHidden = false;
        },

        //滚动菜单到中间位置
        scrollMenuToCenter(target, scrollEle){
            let vW = this.getViewWH().W;
            scrollEle.scrollLeft = target.offsetLeft - vW/2 + target.offsetWidth/2;
        },

        //事件-显示复杂筛选
        event_showComplexScreening(){
            let req_data = this.req_data;
            //必须有数据才可以点击
            if(this.initLoadFlag && this.res_productList.length === 0){ return;}

            for(let attr in req_data){
                if(/^tmp_key__/.test(attr)){
                    let key = attr.replace('tmp_key__', ''),
                        value = req_data[key];

                    if(this.isArray(value)){
                        req_data[attr] = [ ...value ];
                    }else{
                        req_data[attr] = value;
                    }
                }else if(/^tmp_txt__/.test(attr)){
                    let key = attr.replace('tmp_', ''),
                        value = req_data[key];

                    if(this.isArray(value)){
                        req_data[attr] = [ ...value ];
                    }else{
                        req_data[attr] = value;
                    }
                }
            }

            this.hideSortMenu(); //隐藏下拉菜单
            this.showComplexScreening();
        },

        //事件-隐藏复杂筛选
        event_hideComplexScreening(){
            let req_data = this.req_data;
            if(req_data['tmp_key__categoryId']){
                //重新查询筛选条件
                this.filterLoad(
                    {
                        categoryId: '',
                        queryType: 2, //2只查询筛选条件
                        currPage: 1
                    },
                    {
                        fnSuccess: (filteroutlist, newFilterList, req_data) => {
                            //设置新的筛选条件
                            this.setNewFilterData(filteroutlist, newFilterList, req_data);
                            this.hideComplexScreening();
                        }
                    }
                );
            }else{
                this.hideComplexScreening();
            }
        },

        //重置复杂筛选
        event_resetComplexScreening(){
            let req_data = this.req_data;

            if(req_data['tmp_key__categoryId']){
                //重新查询筛选条件
                this.filterLoad(
                    {
                        categoryId: '',
                        queryType: 2, //2只查询筛选条件
                        currPage: 1
                    },
                    {
                        fnSuccess: (filteroutlist, newFilterList, req_data) => {
                            //设置新的筛选条件
                            this.setNewFilterData(filteroutlist, newFilterList, req_data);
                        }
                    }
                );
            }else{
                for(let attr in req_data){
                    if(/^tmp_/.test(attr) && !/orderType$/.test(attr)){
                        if(this.isArray(req_data[attr])){
                            req_data[attr] = [];
                        }else{
                            req_data[attr] = '';
                        }
                    }
                }
            }

            //console.log(JSON.stringify(req_data));
        },

        //确定复杂筛选
        event_submitComplexScreening(){
            let req_data = this.req_data,
                tmp_data = this.getTmpReqData();

            //通用加载
            this.commLoad(
                tmp_data,
                {
                    fnSuccess: (productList) => {

                        for(let attr in req_data){
                            if(/^tmp_key__(?!orderType)/.test(attr)){
                                let key = attr.replace('tmp_key__', ''),
                                    value = req_data[attr];

                                if(this.isArray(value)){
                                    req_data[key] = [ ...value ];
                                }else{
                                    req_data[key] = value;
                                }
                            }else if(/^tmp_txt__/.test(attr)){
                                let key = attr.replace('tmp_', ''),
                                    value = req_data[attr];
                                if(this.isArray(value)){
                                    req_data[key] = [ ...value ];
                                }else{
                                    req_data[key] = value;
                                }
                            }
                        }

                        //console.log(productList);

                        //设置商品数据
                        this.setProductList(productList);
                        this.hideComplexScreening(); //隐藏复杂筛选
                    }
                }
            );
            //console.log(JSON.stringify(req_data));
        },

        //显示复杂筛选
        showComplexScreening(){
            this.isShowComplexScreening = true;
            this.isAddPageHidden = true;
        },

        //隐藏复杂筛选
        hideComplexScreening(){
            this.isShowComplexScreening = false;
            this.isAddPageHidden = false;
        },

        //事件-显示全部分类筛选
        event_showAllCategory(key, index){
            let req_data = this.req_data;

            this.res_filterList.map(item => {
                if(item.key === 'categoryId'){
                    let value = item.value;
                    value.map((item, itemIndex) => {
                        if( itemIndex === index || new RegExp('^'+item.id).test(req_data['tmp_key__'+key]) ){
                            item.isHide = false;
                        }else{
                            item.isHide = true;
                        }
                    });
                }
            });
            this.showAllCategory();
        },

        //事件-隐藏全部分类筛选
        event_hideAllCategory(){
            this.hideAllCategory();
        },

        //显示全部分类筛选
        showAllCategory(){
            this.isShowAllCategory = true;
            this.isAddPageHidden = true;
        },

        //隐藏全部分类筛选
        hideAllCategory(){
            this.isShowAllCategory = false;
            this.isAddPageHidden = false;
        },

        //事件-显示全部品牌筛选
        event_showAllBrand(key){
            let req_data = this.req_data,
                tmp_key = 'tmp_key__' + key,
                tmp2_key = 'tmp2_key__' + key,
                tmp_txt = 'tmp_txt__' + key,
                tmp2_txt = 'tmp2_txt__' + key;

            req_data[tmp2_key] = [ ...req_data[tmp_key] ];
            req_data[tmp2_txt] = [ ...req_data[tmp_txt] ];
            this.showAllBrand();

            //console.log(JSON.stringify(req_data));
        },

        //重置全部品牌
        event_resetAllBrand(){
            let req_data = this.req_data;

            req_data['tmp2_key__brandId'] = [];
            req_data['tmp2_txt__brandId'] = [];
        },

        //确定全部品牌
        event_submitAllBrand(){
            let req_data = this.req_data;

            req_data['tmp_key__brandId'] = [ ...req_data['tmp2_key__brandId'] ];
            req_data['tmp_txt__brandId'] = [ ...req_data['tmp2_txt__brandId'] ];
            this.hideAllBrand();

            // console.log(JSON.stringify(req_data));
        },

        //事件-隐藏全部品牌筛选
        event_hideAllBrand(){
            this.hideAllBrand();
        },

        //显示全部品牌筛选
        showAllBrand(){
            this.isShowAllBrand = true;
            this.isAddPageHidden = true;
        },

        //隐藏全部品牌筛选
        hideAllBrand(){
            this.isShowAllBrand = false;
            this.isAddPageHidden = false;
        },

        //点击弹层提示复制微信管理号
        event_copyWXManage(){
            this.isShowWXManageDialog = true;
        },

        //关闭弹层提示复制微信管理号
        emit_closeWXManageDialog(){
            this.isShowWXManageDialog = false;
        },

        // 打点统计：事件名称-SearchResultClick
        dp_searchResultClick (properties) {

            // 如果是广告的话, 调用接口返回的点击回调
            if (properties.isAd) {
                let cm = properties.adInfo.cm;
                let cmUrl = cm[0].url;
                let oImg = new Image();
                oImg.src = cmUrl + '&_=' + Math.random();
            }

            // 处理属性标签 - 比如：包税/海外|直降/满减/满赠/预售|自营/非自营
            let property_tag = properties.property_tag;
            let sTags = '';
            if (property_tag && property_tag.length) {
                sTags = property_tag.map(item => item.name).join('|');
            }
            properties.property_tag = sTags;

            // 打点事件
            sensors.track(this.doPointEvents[0], properties);
        },

        //返回上一页
        event_goBack(){
            // if(this.QS_from === 'index_search'){
            //     //this.$router.go(-2);
            //     window.location.href = '/';
            // }else{
                this.$router.go(-1);
            //}
        },

        showAlert(data){
            this.$store.dispatch('show_alert', data);
        },
        ...mapMutations({
            set_alert_show: 'SET_ALERT_SHOW',
            set_alert_hide: 'SET_ALERT_HIDE',
            set_alert_data: 'SET_ALERT_DATA',
            set_confirm_show: 'SET_CONFIRM_SHOW',
            set_confirm_hide: 'SET_CONFIRM_HIDE',
            set_confrim_data: 'SET_CONFIRM_DATA'
        }),
        ...mapActions([
            'show_alert'
        ])
    },
    filters: {
        formatNum(num){
            let arr = String(num).split('.');
            return arr[0].replace(/(\d)(?=(\d{3})+$)/g, '$1,') + (arr.length > 1 ? '.' + arr[1] : '');
        },
        getInt(num){
            let arr = String(num).split('.');
            return arr[0];
        },
        getDecimal(num){
            if(~String(num).indexOf('.')){
                return String(num.toFixed(2)).split('.')[1];
            }else{
                return '';
            }
        },
        formatTags(arr){
            let res = [];
            arr.map(item => {
                res.push(item.name);
            });
            return res.join(' | ');
        },
        tagsFormat(tags = [], index) {
            let copyTags = [];
            tags.forEach(tag => copyTags.push(tag.name));

            // let copyTags = [ ...tags ];
            let len = copyTags.length;

            // 1. 先将自营、非自营放到数组的末尾
            // let targetIndex = copyTags.findIndex(item => {
            //     return item.indexOf('自营') !== -1
            // });
            // if (~targetIndex) {
            //     copyTags = copyTags.concat(copyTags.splice(targetIndex, 1));
            // }
            // console.log(copyTags);

            // 2. 再进行筛选
            let start = len - (index + 1);
            let delLen = index;

            copyTags.splice(start, delLen);
            return copyTags.join(' / ');
        },
    },
    watch: {
        '$route' (to, from) {
            //初始化数据
            this.initData();

            //页面及菜单重置到起始位置
            if(this.$refs.page && this.$refs.sortWrap){
                this.$refs.page.scrollTop = this.$refs.sortWrap.children[0].children[0].scrollTop = 0;
            }

            //隐藏搜索面板
            this.emit_hidePanelSearch();

            // 对路由变化作出响应...
            this.initQS(); //初始化获取url参数列表
            this.initLoad(); //初始加载
        }
    },
    components: {
        MDialog,
        MGoodsList,
        MSearch
    }
}
</script>
<style lang="scss" scoped>
.page {
    &-container {
        width: 100%;
        height: 100%;
        background: $bg-main;
    }

    position: absolute;
    overflow: auto;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    -z-index: 100;
    background: $bg-white;

    &-mask {
        position: fixed;
        top: 0;
        z-index: 100;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.6);
        &--transparent {
            background: transparent;
        }
    }

    &-slideMask,
    &-slideContent {
        position: fixed;
        top: 0;
        right: 0;
        z-index: 3000;
    }
    &-slideMask {
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.6);
    }
    &-slideContent {
        overflow: hidden;
        width: toRem(660);
        height: 100%;
        background: $bg-white;

        & .pagehead {
            border-bottom: 1px solid $bd-colorE1;
        }
        & .menu-btns {
            position: absolute;
            bottom: 0rem;
            -webkit-box-sizing: border-box;
            -ms-box-sizing: border-box;
            box-sizing: border-box;
            padding-left: toRem(30);
            padding-right: toRem(30);
            width: 100%;
            background: $bg-white;
            -webkit-box-shadow: 0 0 23px 0 rgba(26, 25, 30, 0.12);
                  box-shadow: 0 0 23px 0 rgba(26, 25, 30, 0.12);
            a {
                color: $color-white;
                background: $color-main;
            }
        }
    }
    &--transparent {
        background: transparent;
    }
    &--noResult {
        .pageContent {
            padding-top: toRem(104);
        }
    }
    &--hidden {
        overflow: hidden;
    }
    &--category .shai {
        bottom: 0;
    }
    .brandlist-selected {
        padding-top: toRem(100);
        padding-right: toRem(200);
        li {
            margin-right: 0;
        }
        span {
            -max-width: toRem(150);
            width: toRem(140);
        }
    }
}
/* 页头 */
.pageHead {
    position: fixed;
    top: 0;
    z-index: 300;
    width: 100%;
    @include transition(transform 0.5s ease);

    &--up {
        @include transform(translate(0, toRem(-84)));
    }
}
.pagehead {
    overflow: hidden;
    position: relative;
    z-index: 500;
    padding: toRem(20) 0  toRem(20);
    max-width: toRem(750);
    height: toRem(64);
    background: $bg-white;

    &-title {
        font-size: toRem(34);
        line-height: toRem(64);
        text-align: center;
    }
    &-likeInput {
        margin-left: toRem(102);
        width: toRem(528);
        height: 100%;
        font-size: toRem(30);
        line-height: toRem(64);
        color: #999;
        background: $bg-main;

        span {
            overflow: hidden;
            display: block;
            margin: 0 auto;
            width: toRem(496);
            @extend %text-ellipsis;
        }
    }

    &-btnBack,
    &-search,
    &-btnSelect {
        position: absolute;
    }
    &-search,
    &-btnBack {
        top: toRem(22);
        width: toRem(60);
        height: toRem(60);
        line-height: toRem(60);
        text-align: center;
    }
    &-btnBack {
        left: toRem(20);
        .iconfont {
            font-size: toRem(38);
        }
    }
    &-search {
        right: 1.46667rem;
        .iconfont {
              font-size: 0.6rem;
        }
    }
    &-btnSelect {
        top: 0.41333rem;
        right: 0.4rem;
        height: 0.56rem;
        font-size: 0.4rem;
        line-height: 0.56rem;
        &--selected {
              color: #F8A120;
        }
        &--gray {
              color: #CCC;
        }
    }
}
/* 主体内容 */
.pageContent {
    padding-top: toRem(104 + 86);

    &--noResult {
        background: $bg-main;
    }
}
/* 品牌旗舰店 */
.brand {
    display: none;
    color: #FFF;
    background: #FFF;
    &-item {
        position: relative;
        margin: 0 toRem(20) toRem(20);
        padding: toRem(70) toRem(30);
        background: #CCC;
    }
    &-row {
        height: toRem(44);
        line-height: toRem(44);
    }
    &-name {
        overflow: hidden;
        margin-right: toRem(132);
        font-size: toRem(34);
        @extend %text-ellipsis;
    }
    &-size {
        height: toRem(38);
        font-size: toRem(26);
        line-height: toRem(38);
    }
    &-enter {
        position: absolute;
        top: toRem(80);
        right: toRem(30);
        font-size: toRem(28);
    }
}
/* 排序主导航 */
.sort {
    @extend %flex-horizontal-between;
    font-size: 0;
    text-align: center;
    &-wapBox {
        padding-bottom: toRem(20);
        background: #FFF;
    }
    &-box {
        height: toRem(66);
    }
    &-wrap {
        position: relative;
        z-index: 300;
        width: toRem(750);
        background: #FFF;
    }
    &-box {
        position: relative;
        z-index: 10;
        overflow: hidden;
        margin: 0rem toRem(20) 0;
        background: #FFF;
    }
    &-item {
        overflow: hidden;
        @include box-sizing(border-box);
        border: 1px solid $bd-colorE1;
        height: toRem(66);
        min-width: toRem(140);
        background-position: center;
        -webkit-background-size: cover;
        -moz-background-size: cover;
        -ms-background-size: cover;
        background-size: cover;

        & span,
        &  i {
            display: inline-block;
            vertical-align: middle;
        }
        & span {
            font-size: toRem(30);
            line-height: toRem(66);
        }
        & img {
            display: block;
            margin: 0 auto;
            max-width: 100%;
            height: 100%;
        }
        &.selected {
            border-color: $color-orange;
            color: $color-orange;
            & i {
                  border-top-color: $color-orange;
            }
        }
        &.show {
            border: 0;
            background-color: $bg-main;
        }
    }
    &-arrow {
        overflow: hidden;
        display: inline-block;
        border: toRem(6) solid transparent;
        border-top-color: #333;
        border-bottom: 0;
        margin-left: toRem(10);
        width: 0;
        height: 0;
        &.left {
            @include transform(rotate(90deg));
        }
        &.up {
            @include transform(rotate(180deg));
        }
        &.right {
            @include transform(rotate(270deg));
        }
    }

    &--2 .sort-item {
        width: toRem(350);
    }
    &--3 .sort-item span,
    &--4 .sort-item span,
    &--more .sort-item span {
        overflow: hidden;
        @extend %text-ellipsis;
    }
    &--3 .sort-item {
        width: toRem(230);
        span {
            max-width: toRem(180);
        }
    }
    &--4 .sort-item {
        width: toRem(170);
        span {
            max-width: toRem(120);
        }
    }
    &--more {
        margin: 0;
        .sort {
            overflow: auto;
            display: block;
            padding: 0 toRem(20);
            height: toRem(120);
            text-align: left;
            white-space: nowrap;
        }
        .sort-item {
            display: inline-block;
            margin-right: toRem(10);
            padding: 0 toRem(10);
            width: toRem(150);
            text-align: center;
            vertical-align: middle;
            span {
                max-width: toRem(90);
            }
            &:first-child {
                width: toRem(180);
                span {
                    max-width: none;
               }
            }
            &:last-child {
                margin-right: 0;
            }
        }
    }
}
/* 排序下拉菜单 */
.sortMenu {
    position: absolute;
    left: 0;
    margin-top: -1px;
    width: 100%;
    padding-top: toRem(24);
    font-size: toRem(28);
    line-height: toRem(40);
    background: $bg-white;
    &-container {
        position: relative;
        z-index: 1;
    }
    &-content {
        overflow: auto;
        @include box-sizing(border-box);
        padding: 0 toRem(30);
        height: 100%;
    }
    &-item {
        overflow: hidden;
        position: relative;
        border-bottom: 1px solid #E1E1E1;
        padding: toRem(30) toRem(50) toRem(30) 0;
        height: toRem(40);
        @extend %text-ellipsis;

        .iconfont {
          display: none;
          position: absolute;
          top: toRem(30);
          right: 0;
          width: toRem(30);
          height: toRem(30);
          font-size: toRem(30);
        }
    }
    .selected {
        span {
            font-weight: bold;
        }
        .iconfont {
            display: block;
        }
    }
    &--2 {
        ul {
            @extend %flex-horizontal-between;
        }
        .sortMenu-item {
            width: toRem(280);
        }
    }
    &--full {
        @include box-sizing(border-box);
        padding-bottom: toRem(130);
        .menu-btns {
            position: absolute;
            bottom: 0;
        }
    }
    &--index {
        z-index: 10;
    }
}
.menu-btns {
    @extend %flex-horizontal-between;
    -webkit-box-flex: 1;
    box-flex: 1;
    flex: 1;
    padding: toRem(20) toRem(30);
    text-align: center;
    a {
        display: block;
        -webkit-box-sizing: border-box;
        -ms-box-sizing: border-box;
        box-sizing: border-box;
        border: 1px solid #999999;
        width: toRem(345);
        height: toRem(90);
        font-size: toRem(30);
        line-height: toRem(90);
    }
    a:nth-of-type(2) {
        border: 0;
        color: #FFF;
        background: #1C1717;
    }
}
/* 商品列表 */
.listGoods {
    @extend %flex-horizontal-between;

    font-size: toRem(24);

    &-item {
        overflow: hidden;
        padding-bottom: toRem(60);
        width: toRem(374);
    }
    &-imgWrp,
    &-imgWrp img,
    &-img {
        display: block;
        width: 100%;
        height: 100%;
        vertical-align: middle;
    }
    &-imgBox {
        overflow: hidden;
        position: relative;
        height: toRem(374);
    }
    &-activeIcon,
    &-presell,
    &-sales,
    &-iconAd {
        position: absolute;
    }
    &-activeIcon {
        top: toRem(20);
        left: toRem(20);

        width: toRem(86);
        height: toRem(86);
    }
    &-presell,
    &-sales {
        bottom: 0;
        left: 0;

        @include box-sizing(border-box);

        text-align:  center;

        color: #FFF;
    }
    &-presell {
        z-index: 100;

        padding: 0 toRem(18) 0 toRem(4);
        width: toRem(150);
        height: toRem(64);

        background-image: url(../../public/img/presell.png);

        background-size: 100% 100%;
    }
    &-presellText,
    &-presellMsg {
        display: block;

        font-size: toRem(20);
        line-height: toRem(28);
    }
    &-presellText,
    &-sales {
        overflow: hidden;
        @extend %text-ellipsis;
    }
    &-presellText {
        padding: toRem(5) toRem(10) 0 0;

        height: toRem(28);
    }
    &-presellMsg {
      white-space: nowrap;
    }
    &-sales {
        padding: toRem(7) toRem(4) 0;
        width: 100%;
        height: toRem(44);

        font-size: toRem(22);
        line-height: toRem(30);

        background-image: -webkit-linear-gradient(-90deg, #FF953E 0%, #FF2626 98%);
        background-image: linear-gradient(-90deg, #FF953E 0%, #FF2626 98%);
        background-size: 100% 100%;

        &.presell {
            padding-left: toRem(144);
        }
    }
    &-iconAd {
        bottom: toRem(8);
        right: toRem(10);

        width: toRem(48);
        height: toRem(26);

        font-size: toRem(18);
        line-height: toRem(26);
        text-align: center;

        color: #FFF;
        background: rgba(0,0,0,0.20);
        @include border-radius(2px);

        &.hasPromotion {
            bottom: toRem(52);
        }
    }
    &-info {
        padding: 0 toRem(30);
    }
    &-brand,
    &-name,
    &-labels {
        overflow: hidden;
        @extend %text-ellipsis;
    }
    &-brand {
        margin-top: toRem(50);
        height: toRem(31);

        line-height: toRem(31);
    }
    &-name {
        margin-top: toRem(8);
        height: toRem(33);

        line-height: toRem(33);
    }
    &-price {
        margin-top: toRem(20);
        height: toRem(48);

        font-size: toRem(34);
        line-height: toRem(48);
        white-space: nowrap;
    }
    &-initPrice,
    &-decimalPrice,
    &-priceLabel,
    &-tipPrice,
    &-tipPriceLabel {
        vertical-align: middle;
    }
    &-decimalPrice {
        font-size: toRem(22);
    }
    &-vipLabel {
        width: toRem(62);
        height: toRem(25);

        background: url(../../public/img/vipTag.png) center left no-repeat;
    }
    &-tagLabel {
        // margin-left: toRem(10);

        padding: 0 toRem(6) 0 toRem(10);
        height: toRem(30);

        font-size: toRem(20);
        line-height: toRem(30);
        color: #E50000;

        background: url(../../public/img/border.png) center left no-repeat;
    }
    &-priceLabel {
        display: inline-block;

        -webkit-background-size: 100% 100%;
        background-size: 100% 100%;

        & em {
            display: inline-block;
            // @include transform(scale(0.833333, 0.833333));
            font-style: normal;
        }
    }
    &-pricing {
        margin-top: toRem(2);
        height: toRem(40);

        font-size: toRem(28);
        line-height: toRem(40);
        color: $color-main;

        white-space: nowrap;
    }
    &-isLine {
        color: $color-gray;

        font-size: toRem(26);
        text-decoration: line-through;
    }
    &-labels {
        margin-top: toRem(14);
        height: toRem(34);

        line-height: toRem(34);

        color: $color-gold;
    }
    &--loading &-info {
        padding: 0;
    }
}
/* 随机背景 */
.rndBg {
    &0 {
      background-color: #f1ede8;
    }
    &1 {
      background-color: #f7f3f3;
    }
    &2 {
      background-color: #f9f8f8;
    }
    &3 {
      background-color: #f7eeed;
    }
    &4 {
      background-color: #F8F8F8;
    }
}
/* 模仿文字效果横线 */
.line {
    margin-top: 0.3rem;
    height: 0.3rem;
    background: #f8f8f8;

    &1 {
        margin-top: 0.5rem;
        width: 1.5rem;
    }
    &2 {
        width: 4.5rem;
    }
    &3 {
        width: 3.2rem;
    }
    &4 {
        width: 2.3rem;
    }
    &5 {
        width: 3.6rem;
    }
}
/* 加载中及加载完全部数据 */
.loadedAllEnd,
.loading {
    padding-bottom: toRem(60);
    height: toRem(30);
    font-size: toRem(26);
    line-height: toRem(30);
    text-align: center;
    color: $color-orange;
    img {
        margin-right: 10px;
        width: toRem(30);
        height: toRem(30);
    }
}
.loadedAllEnd {
    color: $color-main;
}
/* 筛选没有找到数据 */
.notFindedGoods {
    margin-top: toRem(360);
    font-size: toRem(26);
    text-align: center;
}

/* 复杂筛选 */
.shai {
    overflow-y: auto;
    position: absolute;
    top: toRem(110);
    right: 0;
    bottom: toRem(130);
    left: 0;
    padding-bottom: toRem(20);

    &Item {
        border-bottom: 1px solid #E1E1E1;
        margin: 0 toRem(20);
        &-title,
        &-selectedText,
        &-priceMenu li,
        &-menu li,
        &-priceMenu--brands li span,
        &-menu--brands li span  {
            @extend %text-ellipsis;
        }
        &-hd,
        &-priceMenu--brands li,
        &-menu--brands li,
        &-priceMenu,
        &-menu {
            @extend %flex-horizontal-between;
        }
        &-heading {
            position: relative;
            padding-right: toRem(40);
            &--nPr {
                padding-right: 0;
            }
        }
        &-hd {
            overflow: hidden;
            -webkit-box-orient: horizontal;
            -webkit-box-direction: normal;
            -webkit-bo-lines: single;
            -moz-box-lines: single;
            -ms-flex-flow: row nowrap;
            flex-flow: row nowrap;

            padding: toRem(30) 0;
            height: toRem(42);
            font-size: toRem(30);
            line-height: toRem(42);
            span {
                display: block;
            }
            .arrowTip {
                display: inline-block;
                position: relative;
                top: toRem(6);
                left: toRem(4);
            }
        }
        &-arrowTipBox {
            position: absolute;
            top: toRem(36);
            right: 0;
            margin-left: toRem(10);
            width: toRem(32);
            height: toRem(32);
            text-align: center;

            &.left {
                @include transform(rotate(90deg));
            }
            &.up {
                @include transform(rotate(180deg));
            }
            &.right {
                @include transform(rotate(270deg));
            }
        }
        &-selectedText {
            overflow: hidden;
            margin-left: toRem(20);
            font-size: 0.32rem;
            text-align: right;
            text-align: right;
            color: #F8A120;
        }
        &-priceMenu,
        &-menu {
            @include box-pack(start);
            margin: toRem(-10) toRem(-10) 0 0;
            padding-bottom: toRem(40);
            font-size: toRem(26);

            li {
                overflow: hidden;
                @include box-sizing(border-box);
                border: 1px solid #CCC;
                padding: 0 toRem(10);
                margin: toRem(10) toRem(10) 0 0;
                width: toRem(200);
                height: toRem(70);
                line-height: toRem(70);
                text-align: center;
            }
            .selected {
                border-color: #F8A120;
                color: #F8A120;
            }
            .all {
                border: 0;
            }
            .arrowTip {
                margin-left: 0.10667rem;
            }
            &--brands li {
                @include box-pack(center);
                @include box-align(center);
                height: 1.33333rem;
                line-height: 0.44rem;
                span {
                      overflow: hidden;
                      display: block;
                      -margin: 0 toRem(10);
                }
            }
            &--price {
                li span {
                    white-space: normal;
                }
            }
        }
        .priceIptBox {
            @include box-sizing(border-box);
            padding: 0.26667rem 0.13333rem 0;
            width: 3.73333rem;
            padding: toRem(15) toRem(10) toRem(2);
            width: toRem(280);
            line-height: normal;
        }
        .priceLine {
            overflow: hidden;
            margin-top: 0.57333rem;
            width: 0.4rem;
            height: 0.04rem;
            background: #1C1717;
        }
        .priceInput {
            width: 100%;
            height: toRem(36);
            font-size: 0.34667rem;
            line-height: toRem(36);
            text-align: center;
        }
        &--hide &-menu {
            display: none;
        }
    }
    &--hidden {
        overflow: hidden;
    }
}

/* 品牌筛选 */
.brandlist {
    &-container {
        position: absolute;
        top: toRem(105);
        right: 0;
        bottom: toRem(130);
        left: 0;
        .brandlist-box {
            overflow-y: auto;
            height: 100%;
        }
    }
    &-wrap {
        position: absolute;
        left: 0;
        width: 100%;
        background: #FFF;
    }
    &-box {
        position: relative;
        .menu-btns {
            padding-left: toRem(32);
            padding-right: toRem(32);
        }
    }
    &-selectedItem span,
    &-item {
        @extend %text-ellipsis;
    }
    &-selected {
        @extend %flex-horizontal-between;
        padding: toRem(10) 0 toRem(20) toRem(20);
        font-size: 0;
    }
    &-selectedItem {
        display: inline-block;
        @include box-sizing(border-box);
        border: 1px solid #CCC;
        margin: toRem(20) toRem(20) 0 0;
        padding: 0 toRem(10) 0 0.18667rem;
        height: 0.66667rem;
        &-selectedItem span,
        &-selectedItem i {
            display: inline-block;
            vertical-align: middle;
        }
        span {
            overflow: hidden;
            max-width: 2.4rem;
            font-size: 0.32rem;
            line-height: 0.66667rem;
        }
        .iconfont {
            position: relative;
            top: 0.02667rem;
            margin-left: 0.18667rem;
            font-size: 0.18667rem;
            color: #999;
        }
    }
    &-itemTitle,
    &-itemContent {
        padding: 0 toRem(40);
    }
    &-itemTitle {
        height: toRem(60);
        font-size: toRem(30);
        line-height: toRem(60);
        background: #F8F8F8;
    }
    &-itemContent {
        padding-top: toRem(26);
        padding-bottom: toRem(26);
        font-size: toRem(24);
        line-height: toRem(32);
    }
    &-item {
        overflow: hidden;
        position: relative;
        padding: toRem(26) toRem(130) toRem(26) 0;
        height: toRem(32);
        color: #999;
        .iconfont {
            display: none;
            position: absolute;
            top: toRem(32);
            right: toRem(80);
            width: toRem(32);
            height: toRem(32);
            font-size: toRem(32);
        }
    }
    .selected {
        color: #1C1717;
        span {
            font-weight: bold;
        }
        .iconfont {
            display: block;
        }
    }
}
/* A-Z */
.brandKeys {
    position: absolute;
    top: 50%;
    right: toRem(14);
    width: toRem(22);
    -webkit-transform: translate(0, -50%);
    transform: translate(0, -50%);
    color: #3F3F3F;
    font-size: toRem(24);
    text-align: center;
    line-height: toRem(30);
    li {
        height: toRem(30);
    }
    span {
        display: block;
        -webkit-transform: scale(0.83333, 0.83333);
        transform: scale(0.83333, 0.83333);
    }
    .active {
        color: #1C1717;
    }
}

/* 没有搜索记录时 */
.mod-head {
    position: relative;
    padding: toRem(40) 0 toRem(30);
    height: toRem(42);

    font-size: toRem(30);
    line-height: toRem(42);
}
.mod-like {
    background: $bg-white;
    & .mod-head {
        margin: 0 toRem(30);
    }
}
.noResult {
    padding: toRem(72) toRem(60) toRem(62);
    font-size: toRem(30);
    text-align: center;
    word-wrap: break-word;
    word-break: break-all;
    background: #FFF;
    &-msg {
        line-height: toRem(42);
    }
    &-text {
        padding-top: toRem(30);
        font-size: toRem(28);
        line-height: toRem(36);
        color: #999;
    }
    &-btnCopy {
        display: block;
        -webkit-box-sizing: border-box;
        -ms-box-sizing: border-box;
        box-sizing: border-box;
        border: 1px solid #1C1717;
        margin: toRem(30) auto 0;
        width: toRem(380);
        height: toRem(90);
        line-height: toRem(90);
    }
}

/* 弹框复制的内容 */
.longPress {
    &-title {
      margin-top: -0.05rem;
      -webkit-user-select: none;
         -moz-user-select: none;
              user-select: none;
      -ms-user-select: none;
    }
    &-content {
      padding-top: 0.2rem;
    }
}
/* 箭头 */
.arrowTip {
    display: inline-block;
    border: 3px solid #CCC;
    border-top: 0;
    border-left: 0;
    width: 0.18667rem;
    height: 0.18667rem;
    @include transform(rotate(45deg));

    &.right {
        position: relative;
        top: toRem(1);
        @include transform(rotate(315deg));
    }
}
.panel {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 4000;
    background: rgba(0, 0, 0, 0);

    &-warning {
        position: absolute;
        top: 50%;
        @include transform(translate(0, -50%));
        width: 100%;
        line-height: toRem(30);
        text-align: center;
        color: #FFF;

        span {
            display: inline-block;
            padding: toRem(20) toRem(40);
            @include border-radius(5px);
            background: #000;
        }
    }
}

/*  搜索面板 */
.page-search {
    position: fixed;
    top: 0;
    left: 50%;
    z-index: 3000;
    margin-left: toRem(-375);
    width: toRem(750);
    height: 100%;
    background: #FFF;
}

/* 可以设置不同的进入和离开动画 */
.fade-enter-active, .fade-leave-active {
    transition: opacity .3s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}


.slide-left-enter-active, .slide-left-leave-active {
  transition: all .3s ease;
}
.slide-left-enter, .slide-left-leave-to{
  transform: translateX(100%);
}


.slide-down-enter-active {
    @include transition(transform .4s ease);
}
.slide-down-leave-active {
    @include transition(transform .3s ease);
}
.slide-down-enter,
.slide-down-leave-to {
    @include transform(translateY(-100%));
}


.slide-up-enter-active {
    @include transition(transform .4s ease);
}
.slide-up-leave-active {
    @include transition(transform .3s ease);
}
.slide-up-enter,
.slide-up-leave-to {
    @include transform(translateY(100%));
}

</style>



// WEBPACK FOOTER //
// src/pages/List/index.vue